import React, {createContext, useEffect, useRef, useState} from 'react';

import PAAttendee from "../MasterEventObjects/Attendee";
import sample_attendees from "../sampleData/Attendees";


import {
    browserStorageAddEvent,
    browserStorageUpdateAllEvents,
    browserStorageUpdateTemplates,
    ensureStoresExist,
    getAllEventsFromDatabase,
    getAllTemplatesFromDatabase,
    removeAllEventsFromDatabase,
} from './BrowserDatabaseFunctions';
import {openDb} from "./BrowserDatabaseIDB";
import E_uploadEventAttendeePhotosResults, {
    E_addEventPhotoResults, E_deleteEventPhotoResults,
    E_getEventFullSizeImageResults,
    E_getEventThumbnailImageResults,
    E_updateEventAttendeePhotoPrivateResults,
    E_uploadEventAttendeePhotoThumbnailResults,
    E_uploadEventImageResults
} from "../components/EventFeatures/IncomingActions/IncomingEventPhotos";
import E_getEventChangesResults from "../components/EventFeatures/IncomingActions/IncomingEventActions";
import E_setEventAllChangesResults from "../components/EventFeatures/IncomingActions/IncomingEventActions";
import {
    E_addEventActivityResults,
    E_deleteEventActivityResults,
    E_updateEventActivityResults
} from "../components/EventFeatures/IncomingActions/IncomingEventActivities";
import {E_getEventMessagesResults} from "../components/EventFeatures/IncomingActions/IncomingEventMessages";

import E_uploadEventAttendeeReceiptImageResults, {
    E_addEventReceiptResults,
    E_getEventReceiptImageFullSizeResults,
    E_getEventReceiptImageThumbnailResults,
    E_updateEventAttendeeReceiptImagePrivateResults,
    E_uploadEventAttendeeReceiptThumbnailImageResults
} from "../components/EventFeatures/IncomingActions/IncomingEventReceipts";

import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import TimeTable from "../MasterEventObjects/TimeTable";
import {convertEventVersion1To2} from "../components/Helpers/EventConverter";
import usePA_GlobalStore from "./ZustandGlobalStore";
import pako from 'pako';
import {
    E_addEventMealResults,
    E_deleteEventMealResults,
    E_updateEventMealResults
} from "../components/EventFeatures/IncomingActions/IncomingEventMeals";
import {
    E_addEventLodgingResults,
    E_deleteEventLodgingResults,
    E_updateEventLodgingResults
} from "../components/EventFeatures/IncomingActions/IncomingEventLodging";
import {
    E_addEventIdeaCommentResults,
    E_addEventIdeaResults,
    E_deleteEventIdeaResults,
    E_updateEventIdeaResults
} from "../components/EventFeatures/IncomingActions/IncomingEventIdeas";
import {
    E_addEventNoteResults,
    E_deleteEventNoteResults,
    E_updateEventNoteResults
} from "../components/EventFeatures/IncomingActions/IncomingEventNotes";
import {
    E_addNewAttendeeResults,
    E_updateEventAttendeeFieldsResults
} from "../components/EventFeatures/IncomingActions/IncomingEventAttendees";
import {
    getAllContactsFromDatabase,
    removeAllContactsFromDatabase,
    setAllContacts
} from "../components/Restricted/Contacts/BrowserDatabaseFunctions";
import {
    E_getContactsChangesResults,
    updateMasterContactsAttendeeFieldsResults
} from "../components/EventFeatures/IncomingActions/IncomingContactActions";
import {
    addAccountValue, checkForAccountAutoLogin,
    updateAccountValues, deleteAccountDocument, updateAccountDocument, addAccountEssentialItem
} from "../components/Restricted/Account/BrowserDatabaseFunctions";
import {
    addEventPhoto,
    addSignedUrlForPhotoForGCS,
    finalizePhotoInDb
} from "../components/EventFeatures/Photos/BrowserDatabaseFunctions";
import imageCompression from "browser-image-compression";
import {
    addEventCoverImage,
    addEventCoverImageFullSizeAndThumbnail,
    addEventCoverImageThumbnail,
    updateEventCategories,
    updateEventCoverIntro, updateEventStatus,
    updateEventTitle
} from "../components/EventFeatures/Details/BrowserDatabaseFunctions";
import {
    addEventFlights,
    updateEventFlight, updateEventFlightStatus
} from "../components/EventFeatures/Flights/BrowserDatabaseFunctions";
import {
    E_addEventTodoResults, E_deleteEventTodoResults,
    E_updateEventTodoResults
} from "../components/EventFeatures/IncomingActions/IncomingEventTodos";
import {
    addEventAttendees, updateEventAttendeeBudget,
    updateEventAttendeeRole
} from "../components/EventFeatures/Attendees/BrowserDatabaseFunctions";
import {
    addEssentialSupplyItems,
    addNewSupplyItem, deleteSupplyItem, updateSupplyItem,
    updateSupplyItemPrivacy,
    updateSupplyItemStatus
} from "../components/EventFeatures/Supplies/BrowserDatabaseFunctions";
import {
    addEventReceipt,
    deleteEventReceipt,
    updateEventReceipt
} from "../components/EventFeatures/Receipts/BrowserDatabaseFunctions";
import {
    updateEventBusinessAuthorizations
} from "../components/EventFeatures/BusinessAuthorizations/BrowserDatabaseFunctions";
import {PA_Crypto} from "../components/Helpers/PA_Crypto";
import {
    addEventDocumentsBatch,
    deleteEventDocument, updateEventDocument
} from "../components/EventFeatures/Documents/BrowserDatabaseFunctions";
import {updateEventTimetable} from "../components/EventFeatures/DatesTimes/BrowserDatabaseFunctions";
import {addEventMessage} from "../components/EventFeatures/Messages/BrowserDatabaseFunctions";


dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);



const PAContext = createContext();


const PAContextProvider = ({ children }) => {
    console.log("PAContextProvider");

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    let leftoverBytes = new Uint8Array(0);

    const [activeConnectionCount, setActiveConnectionCount] = useState(0);
    const [activeConnectedUsers, setActiveConnectedUsers] = useState({});

    const [ dataArray, setDataArray ] = useState({
        Websocket: null,
        ws_connected: false,
        isMobileView: false,
        showSuccessSnackbar: false,
        progressBar: 0,
        sideMenuWidth: 0,
        Account: {},
        Categories: [],
        Attendees: [],
        SampleAttendees: sample_attendees.map((_att) => ({
            ..._att,
            isSample: true
        })),
        Events: [],

        IncomingActions: [],
        IncomingAccountActions: [],
        IncomingEventActions: [],
        ConciergeActions: [],
        ConciergeMapActions: [],

        ConciergeScanningDocumentActions: [],

        FeaturesPipeline: [],
        LibraryPipeline: [],
        MapPipeline: [],
        ConciergePipeline: [],
        FlightPlanningPipeline: [],
        FlightStatusPipeline: [],
        SuggestionsPipeline: [],
        SignupPipeline: [],
        EventUpgradePipeline: [],
        MessagesPipeline: [],
        SuppliesPipeline: [],
        DialogPipeline: [],
        BusinessExpenseReportPipeline: [],

        authenticated: false,
        loginFailed: false,
        loading: false,
        loadingProgress: 0,

        ConciergePlanning: [],

        SuggestionsLodging: [],
        SuggestionsFlights: [],
        SuggestionsMeals: [],
        SuggestionsTours: [],
        SuggestionsUnique: [],

        PlanningLibrary: [],
        Partnerships: [],
        workingOnEventId: "",

        AdminsActions: [],

    });
    const dataArrayRef = useRef(dataArray);
    const userAccount = useRef(null);
    const [ userAuthenticated, setUserAuthenticated ] = useState(false);

    const receiptBinaryCache = useRef({});
    const registerReceiptBinary = (id, data) => {
        receiptBinaryCache.current[id] = data;
    };

    const documentBinaryCache = useRef({});
    const registerDocumentBinary = (id, data) => {
        documentBinaryCache.current[id] = data;
    };

    const [geminiMessages, setGeminiMessages] = useState(JSON.parse(localStorage.getItem('gemini_chat')) || []);
    useEffect(() => {
        localStorage.setItem('gemini_chat', JSON.stringify(geminiMessages));
    }, [geminiMessages]);
    const [geminiToolCalls, setGeminiToolCalls] = useState("");
    const markMessageAsExecuted = (messageId, created) => {
        setGeminiMessages(prev => prev.map(msg => {
            // Match by unique ID or the timestamp if ID isn't available
            if ((msg.id && msg.id === messageId) || (msg.created === created)) {
                return { ...msg, wasExecuted: true };
            }
            return msg;
        }));
    };


    useEffect(() => {
        dataArrayRef.current = dataArray;
    }, [dataArray]);

    useEffect(() => {
        console.log("----------------------- the userAccount has been updated : "+JSON.stringify(userAccount, null, '\t'));
    }, [userAccount]);
    useEffect(() => {
        console.log("----------------------- the userAuthenticated has been updated : "+JSON.stringify(userAuthenticated, null, '\t'));
    }, [userAuthenticated]);



    const setWsConnected = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            ws_connected: value,
        }));
    };
    const setIsMobileView = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            isMobileView: value,
        }));
    };
    const setShowSuccessSnackbar = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            showSuccessSnackbar: value,
        }));
    };
    const setProgressBar = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            progressBar: value,
        }));
    };
    const setSideMenuWidth = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            sideMenuWidth: value,
        }));
    };
    const setAccount = (value) => {
        console.log("!!!! SETTING ACCOUNT");
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Account: value,
        }));
    };
    const updateGlobalAccount = (updatedFields) => {
        console.log("!!!! UPDATING ACCOUNT FIELDS", updatedFields);
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Account: {
                ...prevDataArray.Account,
                ...updatedFields, // Overwrites only the changed fields
            },
        }));
    };
    const setAccountDocumentArray = (update) => {
        setDataArray((prevDataArray) => {
            // Handle both direct arrays and functional updates (prev => [...prev])
            const currentDocs = prevDataArray.Account?.documents || [];
            const nextDocs = typeof update === 'function' ? update(currentDocs) : update;

            return {
                ...prevDataArray,
                Account: {
                    ...prevDataArray.Account,
                    documents: nextDocs
                }
            };
        });
    };
    const clearAccount = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Account: {},
        }));
    };

    const addEvent = (newEvent) => {

        console.log("adding an Event to dataArray.Events!! : "+newEvent.title+" : "+newEvent.name);
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Events: [...prevDataArray.Events, newEvent],
        }));
    };
    const updateEvent = (updatedEvent) => {
        console.log("Updating an Event in dataArray.Events: ", updatedEvent);

        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const eventIndex = prevDataArray.Events.findIndex(event => event.id === updatedEvent.id);

            if (eventIndex !== -1) {
                // Update the existing event
                const updatedEvents = [...prevDataArray.Events];
                updatedEvents[eventIndex] = updatedEvent;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                console.warn("Event not found. No update performed.");
                return prevDataArray; // No change if the event doesn't exist
            }
        });
    };
    const updateEventLodging = (event_id, updatedEventLodgingArray) => {
        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const index = prevDataArray.Events.findIndex((event) => event.id === event_id);

            if (index !== -1) {
                // If the event exists, replace the lodging with the updated Lodgings
                const updatedEvents = [...prevDataArray.Events];
                updatedEvents[index].lodging = updatedEventLodgingArray;
                updatedEvents[index].need_to_save = true;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                // If the event doesn't exist, simply return the previous state
                return prevDataArray;
            }
        });
    };
    const updateEventActivities = (event_id, updatedEventActivitiesArray) => {
        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const index = prevDataArray.Events.findIndex((event) => event.id === event_id);

            if (index !== -1) {
                // If the event exists, replace the activities with the updated Activities
                const updatedEvents = [...prevDataArray.Events];
                updatedEvents[index].activities = updatedEventActivitiesArray;
                updatedEvents[index].need_to_save = true;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                // If the event doesn't exist, simply return the previous state
                return prevDataArray;
            }
        });
    };
    const updateEventMeals = (event_id, updatedEventMealsArray) => {
        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const index = prevDataArray.Events.findIndex((event) => event.id === event_id);

            if (index !== -1) {
                // If the event exists, replace the meals with the updated Meals
                const updatedEvents = [...prevDataArray.Events];
                updatedEvents[index].meals = updatedEventMealsArray;
                updatedEvents[index].need_to_save = true;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                // If the event doesn't exist, simply return the previous state
                return prevDataArray;
            }
        });
    };
    const updateEventFlights = (event_id, updatedEventFlightsArray) => {
        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const index = prevDataArray.Events.findIndex((event) => event.id === event_id);

            if (index !== -1) {
                // If the event exists, replace the flights with the updated Flights
                const updatedEvents = [...prevDataArray.Events];
                updatedEvents[index].flights = updatedEventFlightsArray;
                updatedEvents[index].need_to_save = true;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                // If the event doesn't exist, simply return the previous state
                return prevDataArray;
            }
        });
    };
    const updateEventMessages = (_incoming) => {
        console.log("updateEventMessages");

        setDataArray((prevDataArray) => {
            // Find the index of the event to update
            const index = prevDataArray.Events.findIndex((event) => event.id === _incoming.event_id);

            if (index !== -1) {
                // If the event exists, replace the messages with the updated Messages
                const updatedEvents = [...prevDataArray.Events];

                // Combine current messages with new, checking for duplicates
                const currentMessageIds = new Set(updatedEvents[index].messages.map(msg => msg.id));
                const newMessages = _incoming.messages_list.filter(msg => !currentMessageIds.has(msg.id));

                // Proceed with adding the new messages if they are not already present
                const updatedMessages = [...updatedEvents[index].messages, ...newMessages];

                // Calculate the latest timestamp
                const latest_message_timestamp = updatedMessages.reduce((latest, message) => {
                    return latest > message.created ? latest : message.created;
                }, 0); // Start with 0 or an initial very old timestamp

                updatedEvents[index].messages = updatedMessages;
                updatedEvents[index].latest_message_timestamp = latest_message_timestamp;
                updatedEvents[index].need_to_save = true;

                return {
                    ...prevDataArray,
                    Events: updatedEvents,
                };
            } else {
                // If the event doesn't exist, simply return the previous state
                return prevDataArray;
            }
        });
    };
    const clearEvents = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Events: [],
        }));
    };

    const addCategory = (newCategory) => {
        setDataArray((prevDataArray) => {
            const existingIndex = prevDataArray.Categories.findIndex(
                (cat) => cat.id === newCategory.id
            );

            let updatedCategories;

            if (existingIndex !== -1) {
                // 🔁 Replace existing category
                updatedCategories = [...prevDataArray.Categories];
                updatedCategories[existingIndex] = newCategory;
            } else {
                // ➕ Add new category
                updatedCategories = [...prevDataArray.Categories, newCategory];
            }

            return {
                ...prevDataArray,
                Categories: updatedCategories,
            };
        });
    };
    const clearCategories = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Categories: [],
        }));
    };

    const addAttendee = (newAttendee) => {
        setDataArray((prevDataArray) => {
            const exists = prevDataArray.Attendees.some(
                (a) => a.id === newAttendee.id
            );

            if (exists) {
                // already exists — skip adding
                return prevDataArray;
            }

            return {
                ...prevDataArray,
                Attendees: [...prevDataArray.Attendees, newAttendee],
            };
        });
    };

    const updateAttendee = (updatedAttendee) => {

        console.log("updating the specific Attendee : ", updatedAttendee);

        //find the Attendee and update it
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Attendees: [...prevDataArray.Attendees.map((attendee) =>
                attendee.id === updatedAttendee.id ? updatedAttendee : attendee
            )]
        }));
    };
    const clearAttendees = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Attendees: [],
        }));
    };
    const addIncomingActions = (newIncomingActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            IncomingActions: [...prevDataArray.IncomingActions, newIncomingActions],
        }));
    };
    const addIncomingAccountActions = (newIncomingAccountActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            IncomingAccountActions: [...prevDataArray.IncomingAccountActions, newIncomingAccountActions],
        }));
    };
    const removeFirstAccountActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            IncomingAccountActions: prevDataArray.IncomingAccountActions.slice(1), // Removes the first element
        }));
    };
    const addIncomingEventActions = (newIncomingEventActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            IncomingEventActions: [...prevDataArray.IncomingEventActions, newIncomingEventActions],
        }));
    };
    const addIncomingConciergeActions = (newIncomingConciergeActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            ConciergeActions: [...prevDataArray.ConciergeActions, newIncomingConciergeActions],
        }));
    };
    const addIncomingConciergeMapActions = (newIncomingConciergeMapActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            ConciergeMapActions: [...prevDataArray.ConciergeMapActions, newIncomingConciergeMapActions],
        }));
    };

    const addIncomingConciergeScanningDocumentActions = (newIncomingConciergeScanningDocumentActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            ConciergeScanningDocumentActions: [...prevDataArray.ConciergeScanningDocumentActions, newIncomingConciergeScanningDocumentActions],
        }));
    };

    const addIncomingFlightPlanningActions = (newIncomingFlightPlanningActions) => {
        console.log('Incoming Flights:', newIncomingFlightPlanningActions);
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            FlightPlanningPipeline: [...prevDataArray.FlightPlanningPipeline, newIncomingFlightPlanningActions],
        }));
    };
    const removeFirstFlightPlanningActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            FlightPlanningPipeline: prevDataArray.FlightPlanningPipeline.slice(1), // Removes the first element
        }));
    };
    const addIncomingFlightStatusActions = (newIncomingFlightStatusActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            FlightStatusPipeline: [...prevDataArray.FlightStatusPipeline, newIncomingFlightStatusActions],
        }));
    };
    const removeFirstFlightStatusActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            FlightStatusPipeline: prevDataArray.FlightStatusPipeline.slice(1), // Removes the first element
        }));
    };
    const addIncomingConciergeSuggestionActions = (newIncomingConciergeSuggestionActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsPipeline: [...prevDataArray.SuggestionsPipeline, newIncomingConciergeSuggestionActions],
        }));
    };

    const addIncomingConciergeSignupActions = (newIncomingConciergeSignupActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SignupPipeline: [...prevDataArray.SignupPipeline, newIncomingConciergeSignupActions],
        }));
    };
    const removeFirstConciergeSignupActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            SignupPipeline: prevDataArray.SignupPipeline.slice(1), // Removes the first element
        }));
    };

    const addIncomingEventUpgradeActions = (newIncomingEventUpgradeActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            EventUpgradePipeline: [...prevDataArray.EventUpgradePipeline, newIncomingEventUpgradeActions],
        }));
    };
    const removeFirstEventUpgradeActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            EventUpgradePipeline: prevDataArray.EventUpgradePipeline.slice(1), // Removes the first element
        }));
    };
    const addIncomingMessagesActions = (newIncomingMessagesActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            MessagesPipeline: [...prevDataArray.MessagesPipeline, newIncomingMessagesActions],
        }));
    };
    const removeFirstMessagesActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            MessagesPipeline: prevDataArray.MessagesPipeline.slice(1), // Removes the first element
        }));
    };
    const addIncomingSuppliesActions = (newIncomingSuppliesActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuppliesPipeline: [...prevDataArray.SuppliesPipeline, newIncomingSuppliesActions],
        }));
    };
    const removeFirstSuppliesActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            SuppliesPipeline: prevDataArray.SuppliesPipeline.slice(1), // Removes the first element
        }));
    };


    const setAuthenticated = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            authenticated: value,
        }));
    };
    const setLoginFailed = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            loginFailed: value,
        }));
    };
    const setPlanning = (_new_planning_event) => {
        console.log("setPlanning _new_planning_event : "+JSON.stringify(_new_planning_event, null, '\t'));

        if (_new_planning_event.title !== ''){
            setDataArray((prevDataArray) => ({
                ...prevDataArray,
                Planning: _new_planning_event
            }));

            /*
                see if there's an Event in browser storage that needs to be updated as well
             */

        }

    };

    function updatePlanningTimeTable(){
        console.log("updatePlanningTimeTable");

        /*
            go through all of the different features (activities, flights, lodging, meals) to update the Event timetable
            so it encompasses all of the dates/days
         */

        const { activities, meals, lodging, flights } = dataArray.current.Planning;

        let minDate = null;
        let maxDate = null;

        // Helper function to update min and max dates
        const updateMinMaxDates = (date) => {
            const parsedDate = dayjs(date, 'MM/DD/YYYY'); // Assuming date format is MM/DD/YYYY
            if (!parsedDate.isValid()) return;

            if (minDate === null || parsedDate.isBefore(minDate)) {
                minDate = parsedDate;
            }
            if (maxDate === null || parsedDate.isAfter(maxDate)) {
                maxDate = parsedDate;
            }
        };

        // Process Activities (assuming they have begin_date and end_date)
        activities.forEach((activity) => {
            updateMinMaxDates(activity.begin_date);
            updateMinMaxDates(activity.end_date);
        });

        // Process Meals (assuming they have a date)
        meals.forEach((meal) => {
            updateMinMaxDates(meal.date);
        });

        // Process Lodgings (assuming they have begin_date and end_date)
        lodging.forEach((_lodging) => {
            updateMinMaxDates(_lodging.begin_date);
            updateMinMaxDates(_lodging.end_date);
        });

        // Process Flights (assuming they have depart_timestamp and arrive_timestamp)
        flights.forEach((flight) => {
            const departDate = dayjs(flight.depart_timestamp);  // Assuming timestamp format is valid ISO format
            const arriveDate = dayjs(flight.arrive_timestamp);
            updateMinMaxDates(departDate.format('MM/DD/YYYY'));  // Convert timestamp to date
            updateMinMaxDates(arriveDate.format('MM/DD/YYYY'));  // Convert timestamp to date
        });

        // If no valid dates found, return an empty TimeTable
        if (!minDate || !maxDate) {
            return new TimeTable();
        }

        // Generate the full range of dates from minDate to maxDate
        const newTimeTable = new TimeTable();
        let currentDate = minDate;
        while (currentDate.isSameOrBefore(maxDate)) {
            newTimeTable.dates.push({
                date: currentDate.format("MM/DD/YYYY"),
                dayOfWeek: currentDate.format("dddd"),
                'all-day': true, // Assuming these are all-day events, modify if needed
                notes: "",       // You can customize this based on the specific event
            });
            currentDate = currentDate.add(1, 'day'); // Move to the next day
        }

//        dataArray.current.Planning['time_table'] = newTimeTable;

        console.log("dataArray.current.Planning : "+JSON.stringify(dataArray.current.Planning, null, '\t'));

    }

    const addPlanningAttendee = (_new_attendee) => {

        console.log("adding new Attendee to Event : "+_new_attendee["fname"]);

        setDataArray((prevDataArray) => {
            const existingAttendeeIndex = prevDataArray.Planning.attendees.findIndex(attendee => attendee.id === _new_attendee.id);

            // If attendee exists, update their status to 0; active
            if (existingAttendeeIndex !== -1) {
                return {
                    ...prevDataArray,
                    Planning: {
                        ...prevDataArray.Planning,
                        attendees: prevDataArray.Planning.attendees.map((attendee, index) =>
                            index === existingAttendeeIndex ? { ...attendee, status: 0 } : attendee
                        ),
                    },
                };
            }

            // If attendee doesn't exist, add them to the attendees array
            return {
                ...prevDataArray,
                Planning: {
                    ...prevDataArray.Planning,
                    attendees: [...prevDataArray.Planning.attendees, _new_attendee],
                },
            };
        });
    };
    const removePlanningAttendee = (_attendee_id) => {
        console.log("removing Attendee from Event");

        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                attendees: prevDataArray.Planning.attendees.map(attendee =>
                    attendee.id === _attendee_id ? { ...attendee, status: 4 } : attendee
                ),
            }
        }));
    };

    const setPlanningBudget = (_budget_total) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                budget_total: _budget_total,
                need_to_save: true
            }
        }));

    };
    const setPlanningBudgetCurrency = (_budget_currency) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                budget_currency: _budget_currency,
                need_to_save: true
            }
        }));

    };

    const setPlanningLodging = (_event_id, _event_lodging_array) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                lodging: _event_lodging_array,
                need_to_save: true
            }
        }));

        updateEventLodging(_event_id, _event_lodging_array);

    };
    const setPlanningActivities = (_event_id, _event_activities_array) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                activities: _event_activities_array,
                need_to_save: true
            }
        }));

        updateEventActivities(_event_id, _event_activities_array);

    };
    const setPlanningMeals = (_event_id, _event_meals_array) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                meals: _event_meals_array,
                need_to_save: true
            }
        }));

        updateEventMeals(_event_id, _event_meals_array);

    };
    const setPlanningFlights = (_event_id, _event_flights_array) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {
                ...prevDataArray.Planning,
                flights: _event_flights_array,
                need_to_save: true
            }
        }));

        updateEventFlights(_event_id, _event_flights_array);

    };

    const addPlanningActivity = (event_id, newEventActivity) => {

        setDataArray((prevDataArray) => {
            // Check if the event_id matches Planning.id

            if (prevDataArray.Planning.id !== event_id) {
                return prevDataArray; // Return previous state without changes
            }

            // Proceed with adding the new activity
            const updatedActivities = [...prevDataArray.Planning.activities, newEventActivity];

            //update the Event Activities
            updateEventActivities(event_id, updatedActivities);

            return {
                ...prevDataArray,
                Planning: {
                    ...prevDataArray.Planning,
                    activities: updatedActivities,
                    need_to_save: true
                }
            };
        });
    };
    const updatePlanningActivity = (event_id, updatedEventActivity) => {

        setDataArray((prevDataArray) => {
            // Check if the event_id matches Planning.id

            if (prevDataArray.Planning.id !== event_id) {
                return prevDataArray; // Return previous state without changes
            }

            // Proceed with updating the activities
            const updatedActivities = prevDataArray.Planning.activities.map(activity =>
                activity.id === updatedEventActivity.id ? updatedEventActivity : activity
            );

            //update the Event Activities
            updateEventActivities(event_id, updatedActivities);

            return {
                ...prevDataArray,
                Planning: {
                    ...prevDataArray.Planning,
                    activities: updatedActivities,
                    need_to_save: true
                }
            };
        });
    };
    const deletePlanningActivity = (event_id, activity_id) => {
        setDataArray((prevDataArray) => {
            // Check if the event_id matches Planning.id
            if (prevDataArray.Planning.id !== event_id) {
                return prevDataArray; // Return previous state without changes
            }

            // Proceed with deleting the activity
            const updatedActivities = prevDataArray.Planning.activities.filter(activity => activity.id !== activity_id);

            //update the Event Activities
            updateEventActivities(event_id, updatedActivities);

            return {
                ...prevDataArray,
                Planning: {
                    ...prevDataArray.Planning,
                    activities: updatedActivities,
                    need_to_save: true
                }
            };
        });
    };


    const addPlanningMessages = (_incoming) => {
        console.log("addPlanningMessages");

        set_PA_GlobalObject((prev) => {
            // Ensure messages exist before mapping
            const existingMessages = prev.Planning.messages || [];

            // Get existing message IDs to prevent duplicates
            const currentMessageIds = new Set(existingMessages.map(msg => msg.id));

            // Filter out messages that already exist
            const newMessages = _incoming.messages_list.filter(msg => !currentMessageIds.has(msg.id));

            // Combine existing and new messages
            const updatedMessages = [...existingMessages, ...newMessages];

            // Find the latest timestamp
            const latestTimestamp = updatedMessages.reduce((latest, message) => {
                return latest > message.created ? latest : message.created;
            }, 0); // Default value 0 ensures a valid timestamp

            return {
                ...prev, // Retain all existing properties
                Planning: {
                    ...prev.Planning, // Keep existing Planning properties
                    messages: updatedMessages,
                    latest_message_timestamp: latestTimestamp,
                    need_to_save: true
                }
            };
        });
    };


    const clearPlanning = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Planning: {},
        }));
    };

    const addSuggestionsLodging = (newSuggestionsLodging) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsLodging: [...prevDataArray.SuggestionsLodging, newSuggestionsLodging],
        }));
    };
    const clearSuggestionsLodging = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsLodging: [],
        }));
    };

    const addSuggestionsFlights = (newSuggestionsFlights) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsFlights: [...prevDataArray.SuggestionsFlights, newSuggestionsFlights],
        }));
    };
    const clearSuggestionsFlights = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsFlights: [],
        }));
    };

    const addSuggestionsMeals = (newSuggestionsMeals) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsMeals: [...prevDataArray.SuggestionsMeals, newSuggestionsMeals],
        }));
    };
    const clearSuggestionsMeals= () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsMeals: [],
        }));
    };

    const addSuggestionsTours = (newSuggestionsUnique) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsTours: [...prevDataArray.SuggestionsTours, newSuggestionsUnique],
        }));
    };
    const clearSuggestionsTours = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsTours: [],
        }));
    };

    const addSuggestionsUnique = (newSuggestionsUnique) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsUnique: [...prevDataArray.SuggestionsUnique, newSuggestionsUnique],
        }));
    };
    const clearSuggestionsUnique = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            SuggestionsUnique: [],
        }));
    };

    const addPlanningLibrary = (newPlanningLibrary) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            PlanningLibrary: [...prevDataArray.PlanningLibrary, newPlanningLibrary],
        }));
    };
    const clearPlanningLibrary = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            PlanningLibrary: [],
        }));
    };
    const addPartnership = (newPartnership) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Partnerships: [...prevDataArray.Partnerships, newPartnership],
        }));
    };
    const clearPartnerships = () => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            Partnerships: [],
        }));
    };
    const setWorkingOnEventId = (value) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            workingOnEventId: value,
        }));
    };



    const addIncomingAdminsActions = (newIncomingAdminsActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            AdminsActions: [...prevDataArray.AdminsActions, newIncomingAdminsActions],
        }));
    };
    const removeFirstIncomingAdminsActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            AdminsActions: prevDataArray.AdminsActions.slice(1), // Removes the first element
        }));
    };

    const addIncomingDialogActions = (newIncomingDialogActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            DialogPipeline: [...prevDataArray.DialogPipeline, newIncomingDialogActions],
        }));
    };
    const removeFirstDialogActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            DialogPipeline: prevDataArray.DialogPipeline.slice(1), // Removes the first element
        }));
    };

    const addIncomingBusinessExpenseReportActions = (newIncomingBusinessExpenseReportActions) => {
        setDataArray((prevDataArray) => ({
            ...prevDataArray,
            BusinessExpenseReportPipeline: [...prevDataArray.BusinessExpenseReportPipeline, newIncomingBusinessExpenseReportActions],
        }));
    };
    const removeFirstBusinessExpenseReportActions = () => {
        setDataArray(prevDataArray => ({
            ...prevDataArray,
            BusinessExpenseReportPipeline: prevDataArray.BusinessExpenseReportPipeline.slice(1), // Removes the first element
        }));
    };


    const websocketRef = useRef(null);
    const messageQueue = useRef([]);
    let [tryingToConnect, setTryingToConnect] = useState(false);

    const sendSocketMessage = (messageObj) => {
        const messageString = JSON.stringify(messageObj) + "|^";
        if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {

            // 1. Tell the UI to show the dots
            usePA_GlobalStore.getState().startSyncing();

            websocketRef.current.send(messageString);
            return;
        }
        messageQueue.current.push(messageString);
        const readyState = websocketRef.current?.readyState;

        if (readyState !== WebSocket.OPEN && readyState !== WebSocket.CONNECTING) {
            console.log("Socket not active. Initiating connection...");
            setWsConnected(false);
            connectWebSocket();
        }
    };

    const connectWebSocket = (onConnectedCallback = null) => {

        if (!tryingToConnect && !dataArray.ws_connected) {
            console.log('Trying to make WebSocket connection...');
            setTryingToConnect(true);

            websocketRef.current = new WebSocket('wss://pacloudrun-1070636036545.us-east1.run.app/ws');
            websocketRef.current.binaryType = "arraybuffer"; // important for gzip bytes

            setDataArray((prevData) => ({ ...prevData, Websocket: websocketRef.current }));

            websocketRef.current.onopen = () => {
                console.log('WebSocket connection established.');
                setWsConnected(true);
                setTryingToConnect(false);

                // 1. MUST AUTHENTICATE FIRST
                if (!userAuthenticated && userAccount.current !== null){
                    console.log('sending a reconnect.');
                    const _loginMsg = {
                        action: "E_processUserLoginReconnect",
                        username: userAccount.current.username,
                        password: userAccount.current.password,
                        last_checkin: userAccount.current.last_checkin
                    };
                    sendSocketMessage(_loginMsg);
                } else {
                    console.log('see if there is an auto_login to use');
                    checkForAccountAutoLogin().then((response) => {
                        if (response){

                            console.log('response : ', response);

                            if (response.auto_login || response.auto_login_type === 'default') {
                                const _send_string = {};
                                _send_string.action = "E_processUserAutoLogin";
                                _send_string.username = response.username;
                                _send_string.password = response.password;

                                sendSocketMessage(_send_string);

                            } else if (response.auto_login_type === "Google") {
                                const _send_string = {};
                                _send_string.action = "E_processUserAutoLoginUsingGoogleJWT";
                                _send_string.username = response.username;
                                _send_string.encrypted_google_account_id = response.encrypted_google_account_id;

                                sendSocketMessage(_send_string);
                            }
                        }
                    });
                }

                // 2. SAFE FLUSH QUEUE
                // Check readyState explicitly so an unexpected transition won't throw
                while (messageQueue.current.length > 0) {
                    if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
                        const msg = messageQueue.current.shift();
                        usePA_GlobalStore.getState().startSyncing();
                        websocketRef.current.send(msg);
                        console.log("Queued message sent.");
                    } else {
                        break; // Stop flushing if socket isn't open
                    }
                }

                // 3. Handle specific callbacks if any
                if (onConnectedCallback) {
                    onConnectedCallback();
                }

                // 4. Use sendSocketMessage instead of raw websocketRef.current.send
                getAllTemplatesFromDatabase().then((_templates) => {
                    if (_templates && Array.isArray(_templates)) {
                        const _template_list = _templates.map((_t) => {
                            const _item = {};
                            _item.template_id = _t.template_id;
                            _item.timestamp = _t.template_timestamp;
                            return _item;
                        });

                        const _sendString = {};
                        _sendString.action = "T_getTemplateChanges";
                        _sendString.current_templates = _template_list;

                        sendSocketMessage(_sendString);
                    }
                });

                if (dataArray.Categories.length === 0){
                    const _sendString = {};
                    _sendString.action = "E_getAllCategories";
                    sendSocketMessage(_sendString);
                }
            };

            websocketRef.current.onmessage = (event) => {
                if (!(event.data instanceof ArrayBuffer)) {
                    console.warn("Unexpected non-binary message received", event.data);
                    return;
                }

                const newBytes = new Uint8Array(event.data);

                // Combine leftover bytes from previous chunk
                const combined = new Uint8Array(leftoverBytes.length + newBytes.length);
                combined.set(leftoverBytes, 0);
                combined.set(newBytes, leftoverBytes.length);

                let offset = 0;
                leftoverBytes = new Uint8Array(0);

                while (offset < combined.length) {
                    const headerByte = combined[offset];
                    const isCompressed = headerByte === 1;

                    if (offset + 1 >= combined.length) {
                        leftoverBytes = combined.slice(offset);
                        break;
                    }

                    if (isCompressed) {
                        // For compressed, we read the next 4 bytes as the length prefix
                        if (offset + 5 > combined.length) {
                            leftoverBytes = combined.slice(offset);
                            break; // wait for more bytes
                        }

                        const lengthView = new DataView(combined.buffer, offset + 1, 4);
                        const compressedLength = lengthView.getUint32(0, false); // big-endian
                        if (offset + 5 + compressedLength > combined.length) {
                            leftoverBytes = combined.slice(offset);
                            break; // wait for full message
                        }

                        const payload = combined.slice(offset + 5, offset + 5 + compressedLength);

                        let decoded;
                        try {
                            decoded = pako.inflate(payload, { to: 'string' });
                        } catch (e) {
                            console.error("Error inflating compressed payload:", e);
                            leftoverBytes = combined.slice(offset);
                            break;
                        }

                        processIncoming(decoded);

                        offset += 5 + compressedLength; // header + length + payload
                    } else {
                        // Plain JSON with terminator
                        const payload = combined.slice(offset + 1);
                        const decoded = new TextDecoder("utf-8").decode(payload);
                        const terminatorIndex = decoded.indexOf("|^");

                        if (terminatorIndex === -1) {
                            leftoverBytes = combined.slice(offset);
                            break; // wait for full message
                        }

                        const completeMessage = decoded.slice(0, terminatorIndex);

                        try {
                            processIncoming(completeMessage);
                        } catch (e) {
                            console.error("Failed to parse JSON:", e, completeMessage);
                        }

                        const consumedBytes = new TextEncoder().encode(decoded.slice(0, terminatorIndex + 2)).length;
                        offset += 1 + consumedBytes;
                    }
                }

                if (offset < combined.length) {
                    leftoverBytes = combined.slice(offset);
                }
            };

            websocketRef.current.onclose = (event) => {
                console.log('WebSocket connection closed:', event.code, event.reason);
                setWsConnected(false);
                setUserAuthenticated(false);
                setActiveConnectionCount(0);
                setActiveConnectedUsers({});
                reconnectWebSocket();
            };

            websocketRef.current.onerror = (error) => {
                console.error('WebSocket error:', error);
                setWsConnected(false);
                setActiveConnectionCount(0);
                setActiveConnectedUsers({});
            };
        }
    };

    const reconnectWebSocket = () => {
        console.log('Reconnecting in 5 seconds...');
        setTimeout(() => {
            if (!dataArray.ws_connected) {
                connectWebSocket();
            }
        }, 5000);
    };






    function processIncoming(messageStr) {
        try {
            processIncomingAction(messageStr);
        } catch (e) {
            console.error("Failed to parse JSON:", e, messageStr);
        }
    }

    async function processIncomingAction(processString) {

        try {
            const _incoming = JSON.parse(processString);
            console.log("the Incoming action : " + JSON.stringify(_incoming.action));

            if (_incoming.action === undefined){
                console.log("the Incoming : " + JSON.stringify(_incoming));
            }

            usePA_GlobalStore.getState().triggerSyncSuccess();

            const latestDataArray = dataArray;

            const action = _incoming.action;



            
            if (action === "timelyUpdate") {

            } else if (action === "S_updateActiveConnectionCount") {
                console.log("S_updateActiveConnectionCount: " , _incoming);

                setActiveConnectionCount(_incoming.count);
                setActiveConnectedUsers(_incoming.active_users);
            } else if (action === "pong") {
                // Reset heartbeat timer on client
                console.log("Pong received from server");

            } else if (action === "E_processUserLoginResults" || action === "E_processUserLoginUsingGoogleJWTResults") {

                processUserLogin(_incoming);

            } else if (action === "E_processUserLogoutResults") {

                processUserLogout(_incoming);

            } else if (action === "E_getAllEventsResults") {
                console.log("Number of events: " + _incoming.events.length);

                const _newly_converted_events = [];
                for (const specificEvent of _incoming.events) {

                    const _event = convertEventVersion1To2(specificEvent);

//                    addEvent(_event);

                    _newly_converted_events.push(_event);
                }

                console.log("@@@@@ added " + _newly_converted_events.length + " events");

                //update the browser database
//                    browserStorageUpdateAllEvents(_incoming.events);
                browserStorageUpdateAllEvents(_newly_converted_events);

            } else if (action === "E_getEventChangesResults") {

                E_getEventChangesResults(_incoming, PA_GlobalObject, set_PA_GlobalObject);

            } else if (action === "E_getAllCategoriesResults") {
                console.log("E_getAllCategoriesResults: ", _incoming.categories);

                for (const _category of _incoming.categories) {
                    addCategory(_category);
                }
            } else if (action === "E_getMasterAttendeeListResults") {
                console.log("Number of attendees: ", _incoming.attendees);

                //this is the source of truth (from the server)
                //so just overwrite anything in the database Contacts
                //and that means get rid of everything and just use this list
                setAllContacts(_incoming.attendees);


                //clear any existing data
                clearAttendees();

                for (const _attendee of _incoming.attendees) {

                    const _newAttendee = new PAAttendee(
                        _attendee.fname,
                        _attendee.lname,
                        _attendee.email
                    );

                    if (userAccount.current.id === _attendee.id) {
                        _newAttendee.role = userAccount.current.role;
                    }
                    _newAttendee.id = _attendee.id;
                    _newAttendee.created = _attendee.created;
                    _newAttendee.image = _attendee.image;
                    _newAttendee.avatar = _attendee.avatar;

                    _newAttendee.nickname = _attendee.nickname;

                    _newAttendee.address = _attendee.address;
                    _newAttendee.city = _attendee.city;
                    _newAttendee.state = _attendee.state;
                    _newAttendee.zip = _attendee.zip;
                    _newAttendee.country = _attendee.country;

                    _newAttendee.dob = _attendee.dob;
                    _newAttendee.language = _attendee.language;

                    _newAttendee.phone_prefix = _attendee.phone_prefix;
                    _newAttendee.phone = _attendee.phone;
                    _newAttendee.mask_phone_number = _attendee.mask_phone_number;

                    _newAttendee.preferred_airport = _attendee.preferred_airport;

                    _newAttendee.push_notifications = _attendee.push_notifications;

                    _newAttendee.events = _attendee.events;

                    _newAttendee.last_mod = _attendee.last_mod;
                    _newAttendee.status = _attendee.status;

                    addAttendee(_newAttendee);
                }





                /*
                    for the Account Details
                 */
            } else if (action === "E_updateAccountPersonalInfoResults") {
                if (_incoming.result === "ok"){
                    updateAccountValues(_incoming.attendee_id, _incoming.updatedFields);
                    addIncomingAccountActions(_incoming);
                }
            } else if (action === "E_updateAccountPersonalInfoAutoLoginResults") {
                if (_incoming.result === "ok"){
                    updateAccountValues(_incoming.attendee_id, _incoming.updatedFields);
                    addIncomingAccountActions(_incoming);
                }
            } else if (action === "E_updateAccountPersonalInfoPasswordResults") {
                if (_incoming.result === "ok"){
                    updateAccountValues(_incoming.attendee_id, _incoming.updatedFields);
                    addIncomingAccountActions(_incoming);
                } else {
                    console.log("Password change failed : ", _incoming.reason);
                }
            } else if (action === "E_updateAccountPersonalInfoNotificationsResults") {
                if (_incoming.result === "ok"){
                    updateAccountValues(_incoming.attendee_id, _incoming.updatedFields);
                    addIncomingAccountActions(_incoming);
                }
            } else if (action === "E_requestAccountDocumentUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {

                    console.log("E_requestAccountDocumentUploadUrlForGCSResults : ", _incoming);

                    const { document_id, upload_url, gcs_path } = _incoming;

                    // 1. Retrieve the cached binary data and passcode from local Ref
                    const cachedData = documentBinaryCache.current[document_id];
                    if (!cachedData) {
                        console.error("No cached binary found for document:", document_id);
                        return;
                    }

                    console.log("cachedData : ", cachedData);
                    const { raw_binary, passcode, file_type, metadata } = cachedData;

                    // 🎯 The Async Execution Block
                    const executeVaultUpload = async () => {
                        try {
                            // 2. MANDATORY ENCRYPTION
                            // We encrypt regardless of whether a user passcode is required.
                            // If no user passcode, we derive a key from a system/user master key.
                            console.log("metadata.passcode_needed : ", metadata.passcode_needed);
                            console.log("passcode : ", passcode);
                            console.log("userAccount.current.id : ", userAccount.current.id);
                            const encryptionKey = (metadata.passcode_needed && passcode) ? passcode : userAccount.current.id;
                            console.log("encryptionKey : ", encryptionKey);

                            console.log("🔒 Encrypting document for secure transit...");
                            const encryptionResult = await PA_Crypto.encrypt(raw_binary, encryptionKey);

                            // encryptionResult should return: { cipherText, iv, salt }
                            const dataToUpload = encryptionResult.cipherText;

                            // 3. Perform the PUT to GCS
                            // We use 'application/octet-stream' because the file is now an encrypted binary blob
                            const gcsResponse = await fetch(upload_url, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/octet-stream' },
                                body: dataToUpload
                            });

                            if (gcsResponse.ok) {
                                console.log("☁️ GCS Upload Successful. Finalizing database record...");

                                // 4. Prepare the completed document object for the server
                                const finalDocument = {
                                    ...metadata,
                                    data: gcs_path,
                                    file_location: gcs_path,
                                    temp_id: document_id,
                                    encrypted: true,
                                    is_finalized: true,
                                    iv: Array.from(encryptionResult.iv),
                                    salt: Array.from(encryptionResult.salt),
                                };

                                // 5. Update local UI (Keep the "Saving..." state/spinner active)
                                setAccountDocumentArray(prev =>
                                    prev.map(d => d.id === document_id ? finalDocument : d)
                                );

                                // 6. Update browser database
                                await updateAccountDocument(userAccount.current.id, finalDocument);

                                // 7. Tell Server to move from GCS to MongoDB permanently
                                console.log("Sending the finalDocument : ", finalDocument);
                                sendSocketMessage({
                                    action: "E_finalizeAccountDocumentUploadUrlForGCS",
                                    document: finalDocument
                                });

                            } else {
                                throw new Error(`GCS Upload Failed: ${gcsResponse.statusText}`);
                            }
                        } catch (err) {
                            console.error("Vault Encryption/Upload Error:", err);
                            alert("Security handshake failed. Please check your connection and try again.");
                        }
                    };

                    executeVaultUpload();
                }
            } else if (action === "E_finalizeAccountDocumentUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {
                    // The server sends back the full document with the NEW MongoDB _id and id
                    const serverDoc = _incoming.document;
                    const tempId = serverDoc.temp_id;

                    setAccountDocumentArray(prev => {
                        // 1. Check if we already have this doc (either by ID or Temp ID)
                        const existingIndex = prev.findIndex(d => d.id === tempId || d.temp_id === tempId || d.id === serverDoc.id);

                        if (existingIndex !== -1) {
                            // SCENARIO: This is the device that did the upload
                            // Replace the spinning placeholder with the real server data
                            const updatedList = [...prev];
                            updatedList[existingIndex] = serverDoc;
                            return updatedList;
                        } else {
                            // SCENARIO: This is the "Other" device
                            // The document is brand new to this tab, so add it to the start of the array
                            return [serverDoc, ...prev];
                        }
                    });

                    // 2. Clear Binary Memory (The file is safe in GCS, wipe the RAM)
                    if (documentBinaryCache.current[tempId]) {
                        delete documentBinaryCache.current[tempId];
                    }

                    // 3. Update browser database
                    await updateAccountDocument(userAccount.current.id, serverDoc);


                    console.log("✅ Vault Handshake Complete. Document Persisted with ID:", serverDoc.id);
                } else {
                    console.error("❌ Finalization error:", _incoming.message);
                    alert("Server failed to save document metadata. Please refresh.");
                }
            } else if (action === "E_requestSignedUrlForAccountDocumentForGCSResults") {
                if (_incoming.result === "ok") {
                    console.log("E_requestSignedUrlForAccountDocumentForGCSResults : ", _incoming);

                    const doc_id = _incoming.document_id;
                    const url = _incoming.signed_url;

                    setAccountDocumentArray(prevDocs => {
                        return prevDocs.map(doc => {
                            // We use String() because we're handling both legacy Longs and String IDs
                            if (String(doc.id) === String(doc_id)) {
                                return {
                                    ...doc,
                                    signedUrl: url,
                                    urlTimestamp: Date.now()
                                };
                            }
                            return doc;
                        });
                    });
                } else {
                    alert("Could not retrieve signed URL: " + _incoming.reason);
                }

            } else if (action === "deleteAccountDocumentResults") {
                if (_incoming.result === "ok"){
                    deleteAccountDocument(_incoming.document_id);
                }




                /*
                   for the Concierge Signup
                */
            } else if (action === "signupConciergeGetWelcomeMessageResults") {
                addIncomingConciergeSignupActions(_incoming);
            } else if (action === "signupConciergeVerifyEmailAddressResults") {
                addIncomingConciergeSignupActions(_incoming);
            } else if (action === "signupConciergeVerifyVerificationCodeResults") {
                addIncomingConciergeSignupActions(_incoming);
            } else if (action === "signupConciergeCheckUsernameAndPasswordResults") {
                addIncomingConciergeSignupActions(_incoming);


            } else if (action?.startsWith("getAllAttendeeAssistantThreadsResults")) {

                addIncomingConciergeActions(_incoming);

            } else if (action?.startsWith("getAttendeeAssistantThreadMessagesResults")) {

                addIncomingConciergeActions(_incoming);


            } else if (action?.startsWith("planningConciergeService")) {

                addIncomingConciergeActions(_incoming);

            } else if (action?.startsWith("planningConciergeChatService")) {

                addIncomingConciergeActions(_incoming);

            } else if (action?.startsWith("planningConciergeMapService")) {

                addIncomingConciergeMapActions(_incoming);

            } else if (action?.startsWith("planningConciergeScanningService")) {

                addIncomingConciergeScanningDocumentActions(_incoming);

            } else if (action?.startsWith("planningConciergeSuggestionService")) {

                addIncomingConciergeSuggestionActions(_incoming);


            } else if (action?.startsWith("adminServicesUpdateOpenAiAssistantThreadUserLoginResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesUpdateOpenAiAssistantThreadUserLogoutResults")) {

                addIncomingAdminsActions(_incoming);


            } else if (action?.startsWith("adminServicesGetOpenAiAssistantFunctionListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetOpenAiAssistantListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesUpdateOpenAiAssistantPropertiesResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesDeleteOpenAiAssistantResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesCreateOpenAiAssistantThreadResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesCreateOpenAiAssistantLodgingNegotiatorThreadResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetOpenAiAssistantThreadListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetOpenAiAssistantThreadMessagesResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesSendOpenAiAssistantThreadMessageResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesSendOpenAiAssistantThreadMessageStatus")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesUpdateOpenAiAssistantThreadMetadataResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesDeleteOpenAiAssistantThreadResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesSetAttendeesAccountPasswordResults")) {

                addIncomingAdminsActions(_incoming);


            } else if (action?.startsWith("adminServicesGetOpenAiFilesListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetOpenAiFileContentsResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetOpenAiFileAssistantListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesDeleteOpenAiFileResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetMasterAttendeeListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesGetMasterEventsListResults")) {

                addIncomingAdminsActions(_incoming);

            } else if (action?.startsWith("adminServicesDeleteEventResults")) {

                addIncomingAdminsActions(_incoming);



                /*
                   for the master Contact list : adding & updating
               */
            } else if (action === "E_getContactsChangesResults") {
                //if anything has changed about the master Contacts
                if (_incoming.result === "ok") {
                    E_getContactsChangesResults(_incoming);
                }
            } else if (action === "addNewMasterContactsAttendeeResults") {
                //this is a response to adding a new Contact from the Contacts Dialog
                addIncomingDialogActions(_incoming);
            } else if (action === "updateMasterContactsAttendeeFieldsResults") {
                //this is a response to making updates from the Contacts Dialog
                if (_incoming.result === "ok") {
                    //for the Dialog to process
                    addIncomingDialogActions(_incoming);

                    //update the browser database
                    updateMasterContactsAttendeeFieldsResults(_incoming);

                    //if they are updating their own Document
                    updateAccountValues(_incoming);
                }


            } else if (action === "E_addNewEventResults") {
                console.log("A new Event just created");

                const newly_converted_event = convertEventVersion1To2(_incoming.newly_created_event);

//                addEvent(newly_converted_event);

                browserStorageAddEvent(newly_converted_event);

                /*
                    for the Event : saving the entire Event from the PLanner
                */
            } else if (action === "E_setEventAllChangesResults") {

                E_setEventAllChangesResults(_incoming, usePA_GlobalStore.getState().PA_GlobalObject.Planning);


                /*
                    for the Event Details
                 */
            } else if (action === "E_updateEventNameResults") {
                if (_incoming.result === "ok") {
                    updateEventTitle(_incoming.event_id, _incoming.event_name);

                    if (_incoming.event_id === PA_GlobalObject.Planning.id
                        && usePA_GlobalStore.getState().PA_GlobalObject.Planning.title !== _incoming.event_name) {
                        set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                title: _incoming.event_name
                            }
                        }));
                    }

                }
            } else if (action === "E_requestEventCoverImageUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {
                    // 1. Pull the object from the Map using the temp_id ("EVENT_COVER")
                    const photo = window.pendingUploads.get("EVENT_COVER");

                    if (photo && photo.file) {
                        // 2. Direct PUT to GCS (The big binary)
                        fetch(_incoming.upload_url, {
                            method: 'PUT',
                            body: photo.file,
                            headers: {'Content-Type': photo.file_type}
                        }).then(response => {
                            if (response.ok) {

                                // Prepare the cover object for the local IndexedDB
                                const coverForDb = {
                                    full: {
                                        file_name: photo.file_name,
                                        file_size: photo.file_size,
                                        file_type: photo.file_type,
                                        width: photo.width,
                                        height: photo.height,
                                        full_data: "", // High-res preview string
                                        gcs_path: _incoming.gcs_path
                                    },
                                    thumbnail: {
                                        thumbnail_data: photo.full_data, // Temporary high-res thumb
                                        width: photo.width,
                                        height: photo.height
                                    }
                                };

                                // Update the local browser database
                                addEventCoverImage(_incoming.event_id, coverForDb)
                                    .then(() => console.log("Local IndexedDB cover updated."))
                                    .catch(err => console.error("IndexedDB Error:", err));


                                // 3. Finalize: Tell the server where the file is
                                // and send the full_data so it can make the thumbnail and update the DB immediately
                                sendSocketMessage({
                                    action: "E_finalizeEventCoverImageUploadUrlForGCS",
                                    event_id: _incoming.event_id,
                                    gcs_path: _incoming.gcs_path,
                                    // Include the metadata so the server can write the full Mongo Doc
                                    photo: {
                                        file_name: photo.file_name,
                                        file_size: photo.file_size,
                                        file_type: photo.file_type,
                                        width: photo.width,
                                        height: photo.height
                                    }
                                });

                                // 4. Cleanup memory
                                window.pendingUploads.delete("EVENT_COVER");
                            }
                        }).catch(err => console.error("Cover GCS Upload Error:", err));
                    }
                }
            } else if (action === "E_finalizeEventCoverImageUploadUrlForGCSResults"){
                if (_incoming.result === "ok") {
                    const eventId = _incoming.event_id;
                    const newCoverImage = _incoming.coverImage; // The structured object from Java

                    // 1. Update Global Store
                    set_PA_GlobalObject((prev) => {
                        // Safety check: ensure we are looking at the right event
                        if (prev.Planning.id !== eventId) return prev;

                        return {
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                // Directly overwrite with the clean, server-approved version
                                coverImage: newCoverImage
                            }
                        };
                    });

                    // 2. Update Browser Database (IndexedDB)
                    // This ensures the local DB is perfectly synced with the server schema
                    addEventCoverImage(eventId, newCoverImage)
                        .then(() => console.log("Local IndexedDB synced with server cover image."))
                        .catch(err => console.error("IndexedDB Sync Error:", err));
                }
            } else if (action === "E_updateEventCoverImageResults") {
                if (_incoming.result === "ok") {
                    if (_incoming.full_data !== undefined){
                        addEventCoverImageFullSizeAndThumbnail(
                            _incoming.event_id,
                            _incoming.file_name,
                            _incoming.full_data,
                            _incoming.thumbnail_data
                        ).then((result) => {
                            if (usePA_GlobalStore.getState().PA_GlobalObject.Planning.id === _incoming.event_id) {
                                set_PA_GlobalObject((prev) => ({
                                    Planning: {
                                        ...prev.Planning, // Retain all existing fields in Planning
                                        file_name: _incoming.file_name,
                                        cover_image_full_data: _incoming.full_data,
                                        cover_image_thumbnail: _incoming.thumbnail_data
                                    },
                                }));
                            }
                        })
                    }
                }
            } else if (action === "E_updateEventCoverImageThumbnailResults") {
                if (_incoming.result === "ok") {
                    addEventCoverImageThumbnail(
                        _incoming.event_id,
                        _incoming.thumbnail_data)
                        .then((result) => {
                        if (usePA_GlobalStore.getState().PA_GlobalObject.Planning.id === _incoming.event_id) {
                            set_PA_GlobalObject((prev) => ({
                                Planning: {
                                    ...prev.Planning, // Retain all existing fields in Planning
                                    cover_image_thumbnail: _incoming.thumbnail_data
                                },
                            }));
                        }
                    });
                }
            } else if (action === "E_updateEventCoverIntroResults") {
                if (_incoming.result === "ok") {
                    updateEventCoverIntro(_incoming.event_id, _incoming.eventIntro);
                    if (_incoming.event_id === PA_GlobalObject.Planning.id) {
                        console.log("Update the Event cover intro");
                        set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                eventIntro: _incoming.eventIntro
                            }
                        }));
                    }

                }
            } else if (action === "E_updateEventCategoriesResults") {
                if (_incoming.result === "ok") {
                    updateEventCategories(_incoming.event_id, _incoming.attendee_id, _incoming.categories);
                    // Ensure we are updating the correct event currently in view
                    if (_incoming.event_id === PA_GlobalObject.Planning.id) {
                        set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                // Map through menu_items to find the specific user who was updated
                                menu_items: prev.Planning.menu_items.map((menu_item) => {
                                    // If the incoming update matches this attendee's ID
                                    if (menu_item.id === _incoming.user_id) {
                                        return {
                                            ...menu_item,
                                            categories: _incoming.categories // Update with new categories
                                        };
                                    }
                                    // Otherwise, return the menu_item as-is
                                    return menu_item;
                                })
                            }
                        }));

                    }
                }
            } else if (action === "E_updateEventTimetableResults") {
                if (_incoming.result === "ok") {

                    //update the browser database
                    updateEventTimetable(_incoming.event_id, _incoming.timetable);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        set_PA_GlobalObject((prev) => ({
                            Planning: {
                                ...prev.Planning,
                                time_table: _incoming.timetable
                            }
                        }));
                    }
                }
            } else if (action === "E_updateEventStatusResults") {
                if (_incoming.result === "ok") {
                    updateEventStatus(_incoming.event_id, _incoming.closed, _incoming.status);
                    if (_incoming.event_id === PA_GlobalObject.Planning.id) {
                        set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                closed: _incoming.closed,
                                status: _incoming.status
                            }
                        }));
                    }

                }



                /*
                    for the Event Attendees
                 */
            } else if (action === "E_addNewAttendeeResults") {
                if (_incoming.result === "ok") {
                    //add new Attendee to the browser database - async
                    addEventAttendees(_incoming.event_id, _incoming.add_attendee_array)

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        //add any new Attendees for this Event
                        const currentAttendees = state.PA_GlobalObject.Planning.attendees || [];

                        // 4. Create a Map of existing IDs to prevent duplicates
                        const existingIds = new Set(currentAttendees.map(a => a.id));

                        // 5. Filter the incoming array for truly "new" people
                        const reallyNewAttendees = _incoming.add_attendee_array.filter(
                            (newAtt) => !existingIds.has(newAtt.id)
                        );

                        if (reallyNewAttendees.length > 0) {
                            // 6. Push the new batch into the Global Store
                            state.set_PA_GlobalObject((prev) => ({
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    attendees: [...currentAttendees, ...reallyNewAttendees]
                                }
                            }));

                            console.log(`Sync: Added ${reallyNewAttendees.length} new attendee(s) to the list.`);
                        }
                    }
                }
            } else if (action === "E_updateEventAttendeeFieldsResults") {
                if (_incoming.result === "ok") {
                    //update the browser database
                    E_updateEventAttendeeFieldsResults(_incoming);
                }
            } else if (action === "E_updateAttendeePrivilegeResults") {
                console.log("E_updateAttendeePrivilegeResults : ", _incoming);
                if (_incoming.result === "ok"){
                    updateEventAttendeeRole(_incoming.event_id, _incoming.attendee_id, _incoming.role);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        const { attendees } = state.PA_GlobalObject.Planning;
                        const normalizedRole = _incoming.role.toLowerCase();

                        // Map the attendees to apply the new role from the server
                        const updatedAttendees = attendees.map((att) => {
                            if (att.id === _incoming.attendee_id) {
                                return {
                                    ...att,
                                    role: normalizedRole,
                                    planner: normalizedRole === 'planner'
                                };
                            }
                            return att;
                        });

                        // Re-derive the host array based on the new roles
                        const updatedHost = updatedAttendees
                            .filter((att) => att.role === 'admin' || att.role === 'master_admin')
                            .map((att) => att.id);

                        // Update the Global Store Object
                        state.set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                attendees: updatedAttendees,
                                host: updatedHost,
                            }
                        }));
                    }
                }
            } else if (action === "E_updateEventAttendeeBudgetResults") {
                console.log("E_updateEventAttendeeBudgetResults : ", _incoming);
                if (_incoming.result === "ok"){
                    updateEventAttendeeBudget(_incoming.event_id, _incoming.attendee_id, _incoming.budget);

                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        const attendees = state.PA_GlobalObject.Planning.attendees || [];

                        // Map and update the precise attendee element matching the user target
                        const updatedAttendees = attendees.map((att) => {
                            if (String(att.id) === String(_incoming.attendee_id)) {
                                return {
                                    ...att,
                                    budget: _incoming.budget // Pure flat object assignment matching Mongo
                                };
                            }
                            return att;
                        });

                        // 🟢 FIXED: Removed the crashing 'updatedHost' variable and safely applied store updates
                        state.set_PA_GlobalObject({
                            ...state.PA_GlobalObject,
                            Planning: {
                                ...state.PA_GlobalObject.Planning,
                                attendees: updatedAttendees
                            }
                        });

                    }
                }


                /*
                    for the Event Documents
                */
            } else if (action === "E_requestEventDocumentUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {

                    console.log("E_requestEventDocumentUploadUrlForGCSResults : ", _incoming);

                    const { event_id, document_id, upload_url, gcs_path } = _incoming;

                    // 1. Retrieve the cached binary data and passcode from local Ref
                    // Note: document_id here is the original 'master' ID before distribution
                    const cachedData = documentBinaryCache.current[document_id];
                    if (!cachedData) {
                        console.error("No cached binary found for event document:", document_id);
                        return;
                    }

                    const { raw_binary, passcode, file_type, metadata, selected_attendee_ids } = cachedData;

                    const executeEventVaultUpload = async () => {
                        try {
                            // 2. ENCRYPTION
                            // Using the passcode if provided, otherwise defaulting to the user's ID
                            const encryptionKey = (metadata.passcode_needed && passcode)
                                ? passcode
                                : event_id; // For Event docs, the fallback is always the Event ID

                            console.log("🔒 Encrypting Event document for secure transit...");
                            const encryptionResult = await PA_Crypto.encrypt(raw_binary, encryptionKey);
                            const dataToUpload = encryptionResult.cipherText;

                            // 3. Perform the PUT to GCS
                            const gcsResponse = await fetch(upload_url, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/octet-stream' },
                                body: dataToUpload
                            });

                            if (gcsResponse.ok) {
                                console.log("☁️ Event GCS Upload Successful. Finalizing for all attendees...");

                                // 4. Prepare the finalized metadata
                                const finalizedMetadata = {
                                    ...metadata,
                                    data: gcs_path,
                                    file_location: gcs_path,
                                    temp_id: document_id, // Keep track of the original request ID
                                    encrypted: true,
                                    is_finalized: true,
                                    iv: Array.from(encryptionResult.iv),
                                    salt: Array.from(encryptionResult.salt),
                                };

                                console.log("☁️ finalizedMetadata ...", finalizedMetadata);

                                // 5. Update local UI (Planning Global Object)
                                // We need to update EVERY document entry that was created for this upload
                                const state = usePA_GlobalStore.getState();

                                console.log("prev.Planning.documents : ", state?.PA_GlobalObject?.Planning?.documents);

                                set_PA_GlobalObject(prev => {
                                    const updatedDocs = prev.Planning.documents.map(doc => {
                                        // Match based on the temp_id we set in handleDocumentAddOK
                                        if (doc.temp_id === document_id) {
                                            console.log("looking at DOC : ", doc);

                                            return {
                                                ...doc,
                                                ...finalizedMetadata,
                                                id: doc.id, // Preserve the attendee-specific unique ID
                                                attendee_id: doc.attendee_id || finalizedMetadata.attendee_id, // Force preserve attendee_id
                                                created_by: doc.created_by
                                            };
                                        }
                                        return doc;
                                    });

                                    console.log("trying to set the event docs to updatedDocs : ", updatedDocs);

                                    return {
                                        ...prev,
                                        Planning: {
                                            ...prev.Planning,
                                            documents: updatedDocs
                                        }
                                    };
                                });

                                // 6. Tell Server to finalize the Event Document and distribute to attendees
                                sendSocketMessage({
                                    action: "E_finalizeEventDocumentUploadUrlForGCS",
                                    event_id: event_id,
                                    document: finalizedMetadata,
                                    attendee_ids: selected_attendee_ids // Crucial for the server to know who gets access
                                });

                            } else {
                                throw new Error(`GCS Event Upload Failed: ${gcsResponse.statusText}`);
                            }
                        } catch (err) {
                            console.error("Event Vault Encryption/Upload Error:", err);
                            alert("Security handshake failed for event document. Please try again.");
                        }
                    };

                    executeEventVaultUpload();
                }
            } else if (action === "E_finalizeEventDocumentUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {
                    console.log("✅ Event Document Finalized and Distributed:", _incoming);

                    const { event_id, documents } = _incoming;

                    //add to browser database
                    addEventDocumentsBatch(event_id, documents);

                    // 1. Identify the original temp_id from the first document in the batch
                    // (All docs in this batch share the same temp_id from the original upload)
                    const sampleDoc = documents[0];
                    const originalTempId = sampleDoc?.temp_id;

                    // 2. Update the Global Planning State
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === event_id) {

                        set_PA_GlobalObject(prev => {
                            // We create a map of the new finalized docs by attendee_id for quick lookup
                            const finalizedMap = new Map(documents.map(d => [d.attendee_id, d]));

                            console.log("finalizedMap : ", finalizedMap);

                            const updatedDocs = prev.Planning.documents.map(doc => {
                                // If this local doc matches the upload we just finished
                                if (doc.temp_id === originalTempId) {
                                    const finalizedData = finalizedMap.get(doc.attendee_id);

                                    console.log("finalizedData : ", finalizedData);

                                    if (finalizedData) {
                                        return {
                                            ...doc,
                                            ...finalizedData,
                                            is_finalized: true // Ensure spinner stops
                                        };
                                    }
                                }
                                return doc;
                            });

                            console.log("the event document(s) should now have unique IDs (without the _attendeeid part");
                            console.log("trying to set the event docs to updatedDocs : ", updatedDocs);

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    documents: updatedDocs
                                }
                            };
                        });
                    }


                    // 3. 🧹 MEMORY CLEANUP
                    // Now that the server has confirmed receipt, we wipe the raw binary from the Ref
                    if (originalTempId && documentBinaryCache.current[originalTempId]) {
                        delete documentBinaryCache.current[originalTempId];
                        console.log(`Inventory: Binary cache cleared for ${originalTempId}`);
                    }

                } else {
                    console.error("❌ Finalization failed:", _incoming.message);
                    alert("The document was uploaded, but we couldn't save the database record. Please try again.");
                }
            } else if (action === "E_requestSignedUrlForEventDocumentForGCSResults") {
                if (_incoming.result === "ok") {
                    console.log("E_requestSignedUrlForEventDocumentForGCSResults : ", _incoming);

                    const event_id = _incoming.event_id;
                    const document_id = _incoming.document_id;
                    const url = _incoming.signed_url;

                    // 2. Update the Global Planning State
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === event_id) {

                        set_PA_GlobalObject(prev => {
                            const updatedDocs = prev.Planning.documents.map(doc => {
                                // Match based on the temp_id we set in handleDocumentAddOK
                                if (doc.id === document_id) {
                                    return {
                                        ...doc,
                                        signedUrl: url,
                                        urlTimestamp: Date.now()
                                    };
                                }
                                return doc;
                            });

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    documents: updatedDocs
                                }
                            };
                        });
                    }

                } else {
                    alert("Could not retrieve signed URL: " + _incoming.reason);
                }
            } else if (action === "E_newEventDocumentAdded") {
                if (_incoming.result === "ok") {
                    const { document } = _incoming;

                    set_PA_GlobalObject(prev => {
                        // Prevent duplicates!
                        // The uploader already updated their UI in the 'finalize' block above.
                        const alreadyExists = prev.Planning.documents.some(d => d.id === document.id);

                        if (alreadyExists) {
                            // Even if it exists, it might be in a 'loading' state.
                            // Let's ensure it's marked as finalized.
                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    documents: prev.Planning.documents.map(d =>
                                        d.id === document.id ? { ...d, ...document, is_finalized: true } : d
                                    )
                                }
                            };
                        }

                        // Otherwise, add it to the top of the list
                        return {
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                documents: [document, ...(prev.Planning.documents || [])]
                            }
                        };
                    });
                }
            } else if (action === "E_updateEventDocumentResults") {
                if (_incoming.result === "ok"){
                    const updatedDocObj = {
                        id: _incoming.document_id,
                        name: _incoming.name,
                        expires: _incoming.expires,
                        private: _incoming.isPrivate,
                        notes: _incoming.notes
                    };

                    // 2. Update Local IndexedDB
                    updateEventDocument(_incoming.event_id, updatedDocObj);

                    // 3. Update Global Zustand State (This triggers the UI refresh)
                    const state = usePA_GlobalStore.getState();
                    const currentPlanning = state.PA_GlobalObject?.Planning;

                    if (currentPlanning && currentPlanning.id === _incoming.event_id) {
                        const updatedDocs = (currentPlanning.documents || []).map(doc =>
                            String(doc.id) === String(_incoming.document_id)
                                ? { ...doc, ...updatedDocObj }
                                : doc
                        );

                        state.set_PA_GlobalObject({
                            ...state.PA_GlobalObject,
                            Planning: {
                                ...currentPlanning,
                                documents: updatedDocs
                            }
                        });
                    }

                }
            } else if (action === "E_deleteEventDocumentResults") {
                if (_incoming.result === "ok"){
                    deleteEventDocument(_incoming.event_id, _incoming.document_id);

                    // 2. Update the Global Planning State
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const currentPlanning = state.PA_GlobalObject?.Planning;

                        // Filter the documents in the global state
                        const updatedDocs = (currentPlanning.documents || [])
                            .filter(doc => String(doc.id) !== String(_incoming.document_id));

                        state.set_PA_GlobalObject({
                            ...state.PA_GlobalObject,
                            Planning: {
                                ...currentPlanning,
                                documents: updatedDocs
                            }
                        });

                    }
                }


                /*
                    for the Event Activities
                */
            } else if (action === "E_addNewActivityResults") {
                if (_incoming.result === "ok") {

                    //add it to the browser database - async
                    E_addEventActivityResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.activity.id;
                        const tempId = _incoming.activity.temp_id;

                        const prevPlanning = state.PA_GlobalObject.Planning || {};
                        const prevActivities = Array.isArray(prevPlanning.activities) ? prevPlanning.activities : [];

                        let replaced = false;

                        const nextActivities = prevActivities.map((act) => {
                            if (tempId && act.temp_id && act.temp_id === tempId) {
                                replaced = true;
                                return { ...act, ..._incoming.activity };
                            }
                            if (newId && act.id === newId) {
                                replaced = true;
                                return { ...act, ..._incoming.activity };
                            }
                            return act;
                        });

                        // If it wasn't replaced, it means another attendee made it -> append it fresh!
                        const finalActivities = replaced ? nextActivities : [...nextActivities, _incoming.activity];

                        // 🟢 FIXED: Apply directly to the store instance without the broken functional scope wrapper
                        state.set_PA_GlobalObject({
                            ...state.PA_GlobalObject,
                            Planning: {
                                ...prevPlanning,
                                activities: finalActivities
                            }
                        });

                        console.log("Activity synced successfully from WebSocket broadcast.");
                    }
                }
            } else if (action === "E_updateEventActivityResults") {
                if (_incoming.result === "ok") {
                    //update the event activity in the browser database - async
                    E_updateEventActivityResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.activities ----
                    const patch = _incoming.activity;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.activities) ? prevPlanning.activities : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.activity.id || (a.temp_id && a.temp_id === _incoming.activity.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view

                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                activities: next,
                            },
                        };
                    });

                }
            } else if (action === "E_deleteEventActivityResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventActivityResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _activity_id = _incoming.activity_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevActivities = Array.isArray(prevPlanning.activities)
                                ? prevPlanning.activities
                                : [];

                            // remove the activity by id
                            const finalActivities = prevActivities.filter((act) => act.id !== String(_activity_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    activities: finalActivities,
                                },
                            };
                        });
                    }
                }


                /*
                   for the Event Meals
                */
            } else if (action === "E_addNewMealResults") {
                if (_incoming.result === "ok") {

                    //add it to the browser database - async
                    E_addEventMealResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.meal.id;
                        const tempId = _incoming.meal.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevMeals = Array.isArray(prevPlanning.meals)
                                ? prevPlanning.meals
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextMeals = prevMeals.map((act) => {
                                if (tempId && act.temp_id && act.temp_id === tempId) {
                                    replaced = true;
                                    return {...act, ..._incoming.meal};
                                }
                                if (newId && act.id === newId) {
                                    replaced = true;
                                    return {...act, ..._incoming.meal};
                                }
                                return act;
                            });

                            const finalMeals = replaced
                                ? nextMeals
                                : [...nextMeals, _incoming.meal];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    meals: finalMeals,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateEventMealResults") {
                if (_incoming.result === "ok") {
                    //update the event meal in the browser database - async
                    E_updateEventMealResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.meals ----
                    const patch = _incoming.meal;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.meals) ? prevPlanning.meals : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.meal.id || (a.temp_id && a.temp_id === _incoming.meal.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view

                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                meals: next,
                            },
                        };
                    });

                }
            } else if (action === "E_deleteEventMealResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventMealResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _meal_id = _incoming.meal_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevMeals = Array.isArray(prevPlanning.meals)
                                ? prevPlanning.meals
                                : [];

                            // remove the meal by id
                            const finalMeals = prevMeals.filter((act) => act.id !== String(_meal_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    meals: finalMeals,
                                },
                            };
                        });
                    }
                }


                /*
                   for the Event Lodging
                */
            } else if (action === "E_addNewLodgingResults") {
                if (_incoming.result === "ok") {

                    //add it to the browser database - async
                    E_addEventLodgingResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.lodging.id;
                        const tempId = _incoming.lodging.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevLodging = Array.isArray(prevPlanning.lodging)
                                ? prevPlanning.lodging
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextLodging = prevLodging.map((act) => {
                                if (tempId && act.temp_id && act.temp_id === tempId) {
                                    replaced = true;
                                    return {...act, ..._incoming.lodging};
                                }
                                if (newId && act.id === newId) {
                                    replaced = true;
                                    return {...act, ..._incoming.lodging};
                                }
                                return act;
                            });

                            const finalLodging = replaced
                                ? nextLodging
                                : [...nextLodging, _incoming.lodging];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    lodging: finalLodging,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateEventLodgingResults") {
                if (_incoming.result === "ok") {
                    //update the event meal in the browser database - async
                    E_updateEventLodgingResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.lodging ----
                    const patch = _incoming.lodging;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.lodging) ? prevPlanning.lodging : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.lodging.id || (a.temp_id && a.temp_id === _incoming.lodging.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view

                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                lodging: next,
                            },
                        };
                    });

                }
            } else if (action === "E_deleteEventLodgingResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventLodgingResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _lodging_id = _incoming.lodging_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevLodging = Array.isArray(prevPlanning.lodging)
                                ? prevPlanning.lodging
                                : [];

                            // remove the lodging by id
                            const finalLodging = prevLodging.filter((act) => act.id !== String(_lodging_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    lodging: finalLodging,
                                },
                            };
                        });
                    }
                }


                /*
                   for the Event Ideas
                */
            } else if (action === "E_addNewIdeaResults") {
                if (_incoming.result === "ok") {

                    //add it to the browser database - async
                    E_addEventIdeaResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.idea.id;
                        const tempId = _incoming.idea.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevIdeas = Array.isArray(prevPlanning.ideas)
                                ? prevPlanning.ideas
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextIdeas = prevIdeas.map((act) => {
                                if (tempId && act.temp_id && act.temp_id === tempId) {
                                    replaced = true;
                                    return {...act, ..._incoming.idea};
                                }
                                if (newId && act.id === newId) {
                                    replaced = true;
                                    return {...act, ..._incoming.idea};
                                }
                                return act;
                            });

                            const finalIdeas = replaced
                                ? nextIdeas
                                : [...nextIdeas, _incoming.idea];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    ideas: finalIdeas,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateEventIdeaResults") {
                if (_incoming.result === "ok") {
                    //update the event idea in the browser database - async
                    E_updateEventIdeaResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.ideas ----
                    const patch = _incoming.idea;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.ideas) ? prevPlanning.ideas : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.idea.id || (a.temp_id && a.temp_id === _incoming.ideal.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view

                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                ideas: next,
                            },
                        };
                    });

                }
            } else if (action === "E_addEventIdeaCommentResults") {
                if (_incoming.result === "ok") {
                    // 1. Update IndexedDB for offline persistence
                    E_addEventIdeaCommentResults(_incoming);

                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevIdeas = Array.isArray(prevPlanning.ideas) ? prevPlanning.ideas : [];

                            // Map through ideas to find the one that matches _incoming.idea_id
                            const finalIdeas = prevIdeas.map((idea) => {
                                // Match the idea (handling both string and number types)
                                if (String(idea.id) === String(_incoming.idea_id)) {
                                    const currentComments = Array.isArray(idea.comments) ? idea.comments : [];
                                    const serverComment = _incoming.comment;

                                    // Check if this comment already exists (via temp_id or server comment_id)
                                    const commentExists = currentComments.some(c =>
                                        (c.temp_id && c.temp_id === serverComment.temp_id) ||
                                        (c.comment_id === serverComment.comment_id)
                                    );

                                    let updatedComments;
                                    if (commentExists) {
                                        // Replace the optimistic/temp comment with the server version
                                        updatedComments = currentComments.map(c =>
                                            (c.temp_id === serverComment.temp_id || c.comment_id === serverComment.comment_id)
                                                ? serverComment
                                                : c
                                        );
                                    } else {
                                        // Add as new if it wasn't found (e.g., a broadcast from another user)
                                        updatedComments = [...currentComments, serverComment];
                                    }

                                    return { ...idea, comments: updatedComments };
                                }
                                return idea; // Not the idea we are looking for
                            });

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    ideas: finalIdeas,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_deleteEventIdeaResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventIdeaResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _idea_id = _incoming.idea_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevIdeas = Array.isArray(prevPlanning.ideas)
                                ? prevPlanning.ideas
                                : [];

                            // remove the idea by id
                            const finalIdeas = prevIdeas.filter((act) => act.id !== String(_idea_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    ideas: finalIdeas,
                                },
                            };
                        });
                    }
                }


                /*
                   for the Event To_Do
                */
            } else if (action === "E_addEventTodoResults") {
                if (_incoming.result === "ok") {

                    // add it to the browser database (fire and forget)
                    E_addEventTodoResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.to_do.id;
                        const tempId = _incoming.to_do.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevTodo = Array.isArray(prevPlanning.to_do)
                                ? prevPlanning.to_do
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextTodo = prevTodo.map((act) => {
                                if (tempId && act.temp_id && act.temp_id === tempId) {
                                    replaced = true;
                                    return {...act, ..._incoming.to_do};
                                }
                                if (newId && act.id === newId) {
                                    replaced = true;
                                    return {...act, ..._incoming.to_do};
                                }
                                return act;
                            });

                            const finalTodo = replaced
                                ? nextTodo
                                : [...nextTodo, _incoming.to_do];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    to_do: finalTodo,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateEventTodoResults") {
                if (_incoming.result === "ok") {

                    //update the event to_do in the browser database - async
                    E_updateEventTodoResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.to_do ----
                    const patch = _incoming.updated_todo_item;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.to_do) ? prevPlanning.to_do : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.updated_todo_item.id || (a.temp_id && a.temp_id === _incoming.updated_todo_item.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view
                        console.log("before merging changes : ", list[idx]);
                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        console.log("after merging changes : ", merged);

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                to_do: next,
                            },
                        };
                    });

                }
            } else if (action === "E_deleteEventTodoResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventTodoResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _to_do_id = _incoming.todo_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevTodos = Array.isArray(prevPlanning.to_do)
                                ? prevPlanning.to_do
                                : [];

                            // remove the to_do by id
                            const finalTodos = prevTodos.filter((act) => act.id !== String(_to_do_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    to_do: finalTodos,
                                },
                            };
                        });
                    }
                }


                /*
                   for the Event Notes
                */
            } else if (action === "E_addNewNoteResults") {
                if (_incoming.result === "ok") {

                    //add it to the browser database - async
                    E_addEventNoteResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.note.id;
                        const tempId = _incoming.note.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevNotes = Array.isArray(prevPlanning.notes)
                                ? prevPlanning.notes
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextNotes = prevNotes.map((act) => {
                                if (tempId && act.temp_id && act.temp_id === tempId) {
                                    replaced = true;
                                    return {...act, ..._incoming.note};
                                }
                                if (newId && act.id === newId) {
                                    replaced = true;
                                    return {...act, ..._incoming.note};
                                }
                                return act;
                            });

                            const finalNotes = replaced
                                ? nextNotes
                                : [...nextNotes, _incoming.note];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    notes: finalNotes,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateEventNoteResults") {
                if (_incoming.result === "ok") {
                    //update the event meal in the browser database - async
                    E_updateEventNoteResults(_incoming);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id !== _incoming.event_id) return;

                    // ---- merge only changed fields into Planning.notes ----
                    const patch = _incoming.note;

                    // tiny helpers (scoped here)
                    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
                    const eq = (a, b) => (a === b) || (Number.isNaN(a) && Number.isNaN(b));
                    const arraysEqual = (a, b) => {
                        if (a === b) return true;
                        if (!Array.isArray(a) || !Array.isArray(b)) return false;
                        if (a.length !== b.length) return false;
                        for (let i = 0; i < a.length; i++) if (!eq(a[i], b[i])) return false;
                        return true;
                    };
                    const mergeChanged = (base, delta) => {
                        if (typeof delta === "undefined") return {merged: base, changed: false};
                        if (!isObj(base) || !isObj(delta)) {
                            return {merged: eq(base, delta) ? base : delta, changed: !eq(base, delta)};
                        }
                        let changed = false;
                        const out = {...base};
                        Object.keys(delta).forEach((k) => {
                            const nv = delta[k];
                            if (typeof nv === "undefined") return; // preserve existing
                            const ov = base[k];
                            if (Array.isArray(nv) || Array.isArray(ov)) {
                                if (!arraysEqual(ov, nv)) {
                                    out[k] = nv;
                                    changed = true;
                                }
                            } else if (isObj(ov) && isObj(nv)) {
                                const r = mergeChanged(ov, nv);
                                if (r.changed) {
                                    out[k] = r.merged;
                                    changed = true;
                                }
                            } else if (!eq(ov, nv)) {
                                out[k] = nv;
                                changed = true;
                            }
                        });
                        return {merged: changed ? out : base, changed};
                    };

                    set_PA_GlobalObject((prev) => {
                        const prevPlanning = prev?.Planning || {};
                        const list = Array.isArray(prevPlanning.notes) ? prevPlanning.notes : [];

                        const idx = list.findIndex(
                            a => a.id === _incoming.note.id || (a.temp_id && a.temp_id === _incoming.note.temp_id)
                        );
                        if (idx < 0) return prev; // nothing to update in current view

                        const {merged, changed} = mergeChanged(list[idx], patch);
                        if (!changed) return prev; // no-op

                        const next = [...list];
                        next[idx] = merged;

                        return {
                            ...prev,
                            Planning: {
                                ...prevPlanning,
                                notes: next,
                            },
                        };
                    });

                }
            } else if (action === "E_deleteEventNoteResults") {
                if (_incoming.result === "ok") {

                    //remove it from the browser database - async
                    E_deleteEventNoteResults(_incoming);

                    //if they are currently working on this event
                    const _event_id = _incoming.event_id;
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _event_id) {

                        const _note_id = _incoming.note_id;
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevNotes = Array.isArray(prevPlanning.notes)
                                ? prevPlanning.notes
                                : [];

                            // remove the note by id
                            const finalNotes = prevNotes.filter((act) => act.id !== String(_note_id));

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    notes: finalNotes,
                                },
                            };
                        });
                    }
                }


            } else if (action === "E_requestPhotoUploadUrlForGCSResults") {
                console.log("E_requestPhotoUploadUrlForGCSResults : ", _incoming);

                // 1. Destructure the echo
                const temp_id = _incoming.temp_id;

                const photo = window.pendingUploads.get(temp_id);
                console.log("photo : ", photo);

                if (photo) {

                    const fileToCompress = photo.file;
                    const options = { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true };
                    // 1. Compress
                    const compressedBlob = await imageCompression(fileToCompress, options);


                    //send to GCS
                    fetch(_incoming.upload_url, {
                        method: 'PUT',
                        body: compressedBlob,      //this is the compressedBlob
                        headers: {'Content-Type': photo.file_type} // Use file_type from metadata
                    }).then(response => {
                        /*
                            at this point the compressed photo is being saved to GCS
                         */
                        console.log("response : ", response);

                        if (response.ok) {
                            console.log("Upload to GCS successful!");

                            //if they are currently working on the same event
                            if (photo.event_id === usePA_GlobalStore.getState().PA_GlobalObject.Planning.id) {
                                console.log("Adding this photo to the Planning.photos");
                                set_PA_GlobalObject((prev) => ({
                                    ...prev,
                                    Planning: {
                                        ...prev.Planning,
                                        photos: prev.Planning.photos.map(p =>
                                            p.temp_id === temp_id ?
                                                {
                                                    ...p,
                                                    gcs_path: _incoming.gcs_path,
                                                    compressedBlob: null,
                                                    full_size_uploaded: true
                                                } : p
                                        )
                                    }
                                }));
                            }

                            //add this to browser storage
                            //but first update some photo properties
                            photo.gcs_path = _incoming.gcs_path;
                            photo.compressedBlob = null;
                            photo.status = 1;         // Mark as active/confirmed
                            photo.full_size_uploaded = true;

                            console.log("Adding this photo to the browser database");
                            addEventPhoto(photo);

                            // Cleanup the Blob from RAM immediately
                            window.pendingUploads.delete(temp_id);
                            console.log("deleted the pendingUpload photo from the window");

                            // 3. Finalize - this means to try to create the thumbnail and save that to GCS
                            const _sendString = {
                                action: "E_finalizePhotoUploadUrlForGCS",
                                photo: photo
                            };

                            console.log("_sendString : ", _sendString);
                            websocketRef.current.send(JSON.stringify(_sendString) + "|^");

                        } else {
                            console.error("GCS Upload failed:", response.status);
                        }
                    }).catch(err => {
                        console.error("Fetch error:", err);
                    });
                }

            } else if (action === "E_finalizePhotoUploadUrlForGCSResults") {
                console.log("E_finalizePhotoUploadUrlForGCSResults : ", _incoming);

                if (usePA_GlobalStore.getState().PA_GlobalObject.Planning.id === _incoming.event_id) {
                    console.log("updating the Planning photos : ");

                    set_PA_GlobalObject((prev) => {
                        // 1. Map through the current photos in state
                        const updatedPhotos = (prev.Planning.photos || []).map(photo => {
                            if (photo.temp_id === _incoming.temp_id) {

                                // 3. Return the photo with its permanent server data
                                return {
                                    ...photo,
                                    id: _incoming.id,            // The permanent Mongo ID
                                    file: "",
                                    full_data: "",
                                    thumbnail_finished: true
                                };
                            }
                            return photo;
                        });


                        return {
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                photos: updatedPhotos
                            }
                        };
                    });
                }

                //update the photo in the browser database to reflect the newly assigned ID
                console.log("updating the browser database photo : ");
                finalizePhotoInDb(_incoming.event_id, _incoming.temp_id, _incoming.id);

                console.log(`Photo ${_incoming.temp_id} is now permanently saved as ${_incoming.id}`);

            } else if (action === "E_requestBatchSignedUrlsForGCSResults") {
                if (_incoming.result === "ok") {
                    const state = usePA_GlobalStore.getState();

                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const currentPhotos = state.PA_GlobalObject.Planning.photos || [];

                        // Map: photo_id -> signed_url
                        const signedUrlsMap = new Map();
                        (_incoming.signed_photos || []).forEach(item => {
                            signedUrlsMap.set(item.photo_id, item.signed_url);
                        });

                        // Update matched photo objects
                        const updatedPhotos = currentPhotos.map(photo => {
                            const targetId = photo.id || photo.temp_id;
                            if (signedUrlsMap.has(targetId)) {
                                const freshUrl = signedUrlsMap.get(targetId);
                                return {
                                    ...photo,
                                    signed_url: freshUrl,
                                    displaySrc: freshUrl // Sets source directly for MemoizedPhotoCard
                                };
                            }
                            return photo;
                        });

                        // Update Zustand global store in a single dispatch
                        state.set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                photos: updatedPhotos
                            }
                        }));
                    }
                } else {
                    console.error("Failed to fetch batch signed URLs:", _incoming.reason);
                }

            } else if (action === "E_requestSignedUrlForPhotoForGCSResults") {
                console.log("E_requestSignedUrlForPhotoForGCSResults : ", _incoming);
                const {event_id, photo_id, temp_id, signed_url, result, reason} = _incoming;

                if (result === "ok") {
                    // Update the state so the image source changes from the spinner to the GCS URL

                    if (usePA_GlobalStore.getState().PA_GlobalObject.Planning.id === event_id) {
                        set_PA_GlobalObject((prev) => {
                            const updatedPhotos = (prev.Planning.photos || []).map(photo => {
                                if (photo.id === photo_id) {
                                    return {...photo, signed_url: signed_url};
                                }
                                return photo;
                            });

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    photos: updatedPhotos
                                }
                            };
                        });
                    }

                    //update the browser database
                    addSignedUrlForPhotoForGCS(event_id, photo_id, signed_url);


                } else {
                    console.error("Could not get viewable URL:", reason);
                }
            } else if (action === "E_addEventPhotoResults") {
                if (_incoming.result === "ok") {
                    E_addEventPhotoResults(_incoming);
                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.photo.id;
                        const tempId = _incoming.photo.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevPhotos = Array.isArray(prevPlanning.photos)
                                ? prevPlanning.photos
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextPhotos = prevPhotos.map((photo) => {
                                if (tempId && photo.temp_id && photo.temp_id === tempId) {
                                    replaced = true;
                                    return {...photo, ..._incoming.photo};
                                }
                                if (newId && photo.id === newId) {
                                    replaced = true;
                                    return {...photo, ..._incoming.photo};
                                }
                                return photo;
                            });

                            const finalPhotos = replaced
                                ? nextPhotos
                                : [...nextPhotos, _incoming.photo];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    photos: finalPhotos,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_uploadEventImageResults") {
                E_uploadEventImageResults(_incoming);
            } else if (action === "E_uploadEventAttendeePhotoThumbnailResults") {
                E_uploadEventAttendeePhotoThumbnailResults(_incoming);
            } else if (action === "E_uploadEventAttendeePhotosResults") {
                E_uploadEventAttendeePhotosResults(_incoming, usePA_GlobalStore.getState().PA_GlobalObject.Planning);
            } else if (action === "E_getEventThumbnailImageResults") {
                E_getEventThumbnailImageResults(_incoming, usePA_GlobalStore.getState().PA_GlobalObject.Planning);
            } else if (action === "E_getEventFullSizeImageResults") {
                E_getEventFullSizeImageResults(_incoming);
            } else if (action === "E_updateEventAttendeePhotoPrivateResults") {
                E_updateEventAttendeePhotoPrivateResults(_incoming);
            } else if (action === "E_deleteEventPhotoResults") {

                if (_incoming.result === "ok") {
                    // 1. Clean up local IndexedDB storage
                    await E_deleteEventPhotoResults(_incoming);

                    // Only update if the user is currently looking at this specific event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        // Push the update back to the Global Store
                        state.set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                photos: (prev.Planning?.photos || []).filter(
                                    (p) => p.id !== _incoming.photo_id
                                ),
                            }
                        }));
                    }
                } else {
                    console.error("Failed to delete photo from server:", _incoming.reason);
                }


                /*
                    for the Event Messages
                */
            } else if (action === "E_getEventMessagesResults") {
                if (_incoming.messages_list.length > 0) {

                    for (const newMessage of _incoming.messages_list) {
                        //add the messages to browser database
                        try {
                            addEventMessage(_incoming.event_id, newMessage);
                            console.log("newMessage added successfully");
                        } catch (error) {
                            console.error("Error adding newMessage: ", error);
                        }

                    }
                    //add this to the Global Planning if IDs match
                    if (_incoming.event_id === usePA_GlobalStore.getState().PA_GlobalObject.Planning.id) {
                        addPlanningMessages(_incoming);
                        addIncomingMessagesActions(_incoming);
                    }

                }
            } else if (action === "E_sendEventMessageResults") {
                if (_incoming.result === "ok"){
                    const eventId = _incoming.event_id;
                    const serverMessage = _incoming.message_data;

                    //add to event in browser database
                    addEventMessage(eventId, _incoming.message_data)


                    // Only update if the user is currently looking at this specific event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === eventId) {

                        const currentMessages = [...(state.PA_GlobalObject.Planning.messages || [])];

                        // Look for the optimistic placeholder using temp_id
                        const existingIndex = currentMessages.findIndex(m =>
                            (serverMessage.temp_id && m.temp_id === serverMessage.temp_id) ||
                            (m.id === serverMessage.id)
                        );

                        if (existingIndex !== -1) {
                            // Replace the "Processing" message with the "Official" server message
                            currentMessages[existingIndex] = {
                                ...serverMessage,
                                isProcessing: false // Ensure the UI knows it's finished
                            };
                        } else {
                            // If it's a message from someone else, just add it to the list
                            currentMessages.push(serverMessage);
                        }

                        // Push the update back to the Global Store
                        state.set_PA_GlobalObject({
                            ...state.PA_GlobalObject,
                            Planning: {
                                ...state.PA_GlobalObject.Planning,
                                messages: currentMessages
                            }
                        });
                    }

                }



                /*
                for things related Event supplies
             */
            } else if (action === "E_addNewSupplyItemResults") {
                if (_incoming.result === "ok"){
                    addNewSupplyItem(_incoming.event_id, _incoming.supply_item);

                    const incomingItem = _incoming.supply_item;

                    if (incomingItem.essential && incomingItem.essential_id !== 0) {

                        // ✅ Map only the Essential Template fields (don't save event-specific data like assigned_to)
                        const essentialTemplate = {
                            category: incomingItem.category,
                            id: incomingItem.essential_id,
                            name: incomingItem.name,
                            notes: incomingItem.notes || "",
                            private: incomingItem.private || false,
                            status: 1,
                            sub_category: incomingItem.sub_category || "General"
                        };

                        addAccountEssentialItem(userAccount.current.id, essentialTemplate).then(() => {

                            // Update Account State safely
                            setAccount(prev => {
                                if (!prev) return prev;

                                const prevEssentials = Array.isArray(prev.essentials) ? prev.essentials : [];
                                const exists = prevEssentials.some(e => e.id === essentialTemplate.id);

                                if (exists) return prev;

                                // IMPORTANT: Ensure we spread the WHOLE prev object
                                // so we don't lose user settings, tokens, or profile info
                                return {
                                    ...prev,
                                    essentials: [...prevEssentials, essentialTemplate]
                                };
                            });
                        });
                    }

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const incomingItem = _incoming.supply_item;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevSupplies = Array.isArray(prevPlanning.supplies)
                                ? prevPlanning.supplies
                                : [];

                            // Check if the item already exists in the store (by ID)
                            const existingIndex = prevSupplies.findIndex(s =>
                                s.id === incomingItem.id || (incomingItem.temp_id && s.temp_id === incomingItem.temp_id)
                            );

                            let finalSupplies;

                            if (existingIndex !== -1) {
                                // ✅ CASE 1: Item exists. Update it in place to preserve the rest of the list.
                                // This handles the "Sender" confirming the add or someone else updating it.
                                finalSupplies = prevSupplies.map((item, index) =>
                                    index === existingIndex ? incomingItem : item
                                );
                            } else {
                                // ✅ CASE 2: Item is new. Append it to the existing list.
                                finalSupplies = [...prevSupplies, incomingItem];
                            }

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    supplies: finalSupplies, // Now guaranteed to be an array
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_addEssentialSupplyItemsResults") {
                if (_incoming.result === "ok"){
                    const newItems = _incoming.added_items || [];
                    const eventId = _incoming.event_id;

                    addEssentialSupplyItems(eventId, newItems);

                    const state = usePA_GlobalStore.getState();

                    // Only update if the user is currently looking at this specific event
                    if (state?.PA_GlobalObject?.Planning?.id === eventId) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevSupplies = Array.isArray(prevPlanning.supplies) ? prevPlanning.supplies : [];

                            // ✅ Create sets for both IDs and Temp IDs to ensure a clean swap
                            const incomingIds = new Set();
                            const incomingTempIds = new Set();

                            newItems.forEach(item => {
                                if (item.id) incomingIds.add(item.id);
                                if (item.temp_id) incomingTempIds.add(item.temp_id);
                            });

                            // ✅ Filter out any item that matches either the new ID OR the Temp ID
                            const existingFiltered = prevSupplies.filter(item =>
                                !incomingIds.has(item.id) &&
                                (!item.temp_id || !incomingTempIds.has(item.temp_id))
                            );

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    supplies: [...existingFiltered, ...newItems]
                                }
                            };
                        });
                    }
                }
            } else if (action === "E_updateSupplyItemResults") {
                if (_incoming.result === "ok") {
                    const updatedItem = _incoming.supply_item;
                    const eventId = _incoming.event_id;

                    // 1. Sync to IndexedDB for offline persistence
                    // (Assuming you have a helper similar to addNewSupplyItem)
                    updateSupplyItem(eventId, updatedItem);

                    // 2. Update Global State
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === eventId) {
                        set_PA_GlobalObject((prev) => {
                            const prevSupplies = Array.isArray(prev?.Planning?.supplies)
                                ? prev.Planning.supplies
                                : [];

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    supplies: prevSupplies.map((item) =>
                                        item.id === updatedItem.id ? updatedItem : item
                                    ),
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateSupplyItemPrivacyResults") {
                if (_incoming.result === "ok"){
                    updateSupplyItemPrivacy(_incoming.event_id, _incoming.item_id, _incoming.private);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevSupplies = Array.isArray(prevPlanning.supplies)
                                ? prevPlanning.supplies
                                : [];

                            // Update only the item that changed
                            const finalSupplies = prevSupplies.map(s =>
                                s.id === _incoming.item_id
                                    ? { ...s, private: _incoming.private }
                                    : s
                            );

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    supplies: finalSupplies,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateSupplyItemStatusResults") {
                if (_incoming.result === "ok"){
                    updateSupplyItemStatus(_incoming.event_id, _incoming.item_id, _incoming.status);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevSupplies = Array.isArray(prevPlanning.supplies)
                                ? prevPlanning.supplies
                                : [];

                            // Update only the item that changed
                            const finalSupplies = prevSupplies.map(s =>
                                s.id === _incoming.item_id
                                    ? { ...s, status: _incoming.status }
                                    : s
                            );

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    supplies: finalSupplies,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_updateSupplyItemAssignedToResults") {
                if (_incoming.result === "ok"){

                }
            } else if (action === "E_deleteSupplyItemResults") {
                if (_incoming.result === "ok"){
                    const { event_id, item_id } = _incoming;

                    // 1. Sync to local IndexedDB for offline persistence
                    // This ensures if they refresh or go offline, the item stays gone.
                    deleteSupplyItem(event_id, item_id);

                    // 2. Update the Global Zustand Store (UI)
                    const state = usePA_GlobalStore.getState();

                    // Only update if the user is currently looking at this specific event
                    if (state?.PA_GlobalObject?.Planning?.id === event_id) {
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevSupplies = Array.isArray(prevPlanning.supplies)
                                ? prevPlanning.supplies
                                : [];

                            // Filter out the deleted item
                            const finalSupplies = prevSupplies.filter(s => s.id !== item_id);

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    supplies: finalSupplies,
                                },
                            };
                        });
                    }
                }


                /*
                    for the Event Receipts
                */
            } else if (action === "E_addEventReceiptResults") {
                if (_incoming.result === "ok") {
                    //add it to the browser database - async
                    addEventReceipt(_incoming.event_id, _incoming.receipt);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        const newId = _incoming.receipt.id;
                        const tempId = _incoming.receipt.temp_id;

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevReceipts = Array.isArray(prevPlanning.receipts)
                                ? prevPlanning.receipts
                                : [];

                            // replace by temp_id first, else by id
                            let replaced = false;
                            const nextReceipts = prevReceipts.map((recpt) => {
                                if (tempId && recpt.temp_id && recpt.temp_id === tempId) {
                                    replaced = true;
                                    return {...recpt, ..._incoming.receipt};
                                }
                                if (newId && recpt.id === newId) {
                                    replaced = true;
                                    return {...recpt, ..._incoming.receipt};
                                }
                                return recpt;
                            });

                            const finalReceipts = replaced
                                ? nextReceipts
                                : [...nextReceipts, _incoming.receipt];

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    receipts: finalReceipts,
                                },
                            };
                        });
                    }
                }
            } else if (action === "E_requestEventReceiptUploadUrlForGCSResults") {
                if (_incoming.result === "ok") {
                    const { upload_url, gcs_path, receipt_id, event_id, pending_updates } = _incoming;

                    // 1. Get the binary from our local cache
                    const binaryData = receiptBinaryCache.current[receipt_id];

                    if (binaryData) {
                        await (async () => {
                            try {
                                let blob;

                                // 🎯 FIX: Check if full_data is already a File/Blob or a Base64 string
                                if (binaryData.full_data instanceof File || binaryData.full_data instanceof Blob) {
                                    blob = binaryData.full_data;
                                } else {
                                    // It's a Base64 string from a fresh scan
                                    const res = await fetch(binaryData.full_data);
                                    blob = await res.blob();
                                }

                                const upload = await fetch(upload_url, {
                                    method: 'PUT',
                                    body: blob,
                                    headers: { 'Content-Type': binaryData.file_type }
                                });

                                if (upload.ok) {
                                    console.log(`GCS Upload Success for receipt: ${receipt_id}`);

                                    // 4. Clean up the cache
                                    delete receiptBinaryCache.current[receipt_id];

                                    // 5. Build the final receipt object
                                    const finalReceipt = {
                                        ...binaryData,
                                        ...(pending_updates || {}),
                                        full_data: gcs_path, // Now it's the permanent path
                                        full_data_loaded: true
                                    };

                                    // 🎯 NEW: Update the Global Store locally so the UI updates immediately
                                    set_PA_GlobalObject((prev) => {
                                        const newReceipts = prev.Planning.receipts.map(r =>
                                            r.id === receipt_id ? finalReceipt : r
                                        );
                                        return {
                                            ...prev,
                                            Planning: { ...prev.Planning, receipts: newReceipts }
                                        };
                                    });

                                    // 6. Save to Database
                                    if (finalReceipt.id === finalReceipt.temp_id) {
                                        // is a new Receipt
                                        sendSocketMessage({
                                            action: "E_addEventReceipt_v2",
                                            event_id: event_id,
                                            receipt: finalReceipt
                                        });
                                    } else {
                                        // this Receipt was replaced/edited
                                        sendSocketMessage({
                                            action: "E_updateEventReceipt",
                                            event_id: event_id,
                                            receipt: finalReceipt
                                        });
                                    }
                                }
                            } catch (e) {
                                console.error("GCS Upload Error:", e);
                            }
                        })();
                    }
                }
            } else if (action === "E_requestSignedUrlForReceiptForGCSResults") {
                if (_incoming.result === "ok") {
                    const url = _incoming.signed_url;

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        //give the receipt the temp signed GCS url
                        set_PA_GlobalObject((prev) => {
                            const updatedReceipts = (prev.Planning.receipts || []).map((r) => {
                                // Match the receipt by its id
                                if (r.id === _incoming.receipt_id) {
                                    return {
                                        ...r,
                                        signedUrl: url, // Store the temporary signed URL
                                        urlTimestamp: Date.now() // Track when it was generated (optional)
                                    };
                                }
                                return r;
                            });

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    receipts: updatedReceipts
                                }
                            };
                        });
                    }
                } else {
                    alert("Could not retrieve image: " + _incoming.reason);
                }
            } else if (action === "E_updateEventReceiptResults") {
                if (_incoming.result === "ok"){
                    updateEventReceipt(_incoming.event_id, _incoming.receipt);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const currentReceipts = prev.Planning.receipts || [];

                            // Find and replace the specific receipt
                            const updatedReceipts = currentReceipts.map(r =>
                                r.id === _incoming.receipt.id ? _incoming.receipt : r
                            );

                            return {
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    receipts: updatedReceipts
                                }
                            };
                        });
                    }

                }
            } else if (action === "E_uploadEventAttendeeReceiptImageResults") {
                E_uploadEventAttendeeReceiptImageResults(_incoming, PA_GlobalObject, set_PA_GlobalObject);
            } else if (action === "E_uploadEventAttendeeReceiptThumbnailImageResults") {
                E_uploadEventAttendeeReceiptThumbnailImageResults(_incoming, PA_GlobalObject, set_PA_GlobalObject);
            } else if (action === "E_getEventReceiptImageThumbnailResults") {
                E_getEventReceiptImageThumbnailResults(_incoming, usePA_GlobalStore.getState().PA_GlobalObject.Planning);
            } else if (action === "E_getEventReceiptImageFullSizeResults") {
                E_getEventReceiptImageFullSizeResults(_incoming);
            } else if (action === "E_updateEventAttendeeReceiptImagePrivateResults") {
                E_updateEventAttendeeReceiptImagePrivateResults(_incoming);
            } else if (action === "E_deleteEventReceiptResults") {
                if (_incoming.result === "ok"){
                    deleteEventReceipt(_incoming.event_id, _incoming.receipt_id);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevReceipts = Array.isArray(prevPlanning.receipts)
                                ? prevPlanning.receipts
                                : [];

                            const finalReceipts = prevReceipts.filter(r => r.id !== _incoming.receipt_id);

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    receipts: finalReceipts,
                                },
                            };
                        });
                    }
                }


                /*
                    for the Flight Planner and Event Flights
                 */
            } else if (action === "E_getDuffelFlightsResults") {
                addIncomingFlightPlanningActions(_incoming);
            } else if (action === "E_getFlightDetailsResults") {
                addIncomingFlightPlanningActions(_incoming);
            } else if (action === "E_addNewFlightDetailsResults") {
                if (_incoming.result === "ok") {
                    addEventFlights(_incoming.event_id, _incoming.flights);

                    const state = usePA_GlobalStore.getState();

                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = state.PA_GlobalObject.Planning || {};
                            const prevFlights = Array.isArray(prevPlanning.flights) ? prevPlanning.flights : [];

                            // Make a clone of current local view elements to manipulate safely
                            let updatedFlights = [...prevFlights];

                            // 3. Process every incoming server flight record cleanly
                            _incoming.flights.forEach(newFlight => {
                                let replaced = false;

                                updatedFlights = updatedFlights.map(oldFlight => {
                                    // Match Case A: Check transient creation tokens
                                    if (newFlight.temp_id && oldFlight.temp_id === newFlight.temp_id) {
                                        replaced = true;
                                        return { ...oldFlight, ...newFlight };
                                    }
                                    // Match Case B: Check database primary keys
                                    if (newFlight.id && oldFlight.id === newFlight.id) {
                                        replaced = true;
                                        return { ...oldFlight, ...newFlight };
                                    }
                                    return oldFlight;
                                });

                                // If it didn't replace anything, it was created by a peer attendee -> add it fresh
                                if (!replaced) {
                                    updatedFlights.push(newFlight);
                                }
                            });

                            // 4. Update the Zustand store instance in a single, unified commit operation
                            state.set_PA_GlobalObject({
                                ...state.PA_GlobalObject,
                                Planning: {
                                    ...prevPlanning,
                                    flights: updatedFlights,
                                },
                            });
                        });
                    }
                }
            } else if (action === "E_updateFlightDetailsResults") {
                if (_incoming.result === "ok") {
                    updateEventFlight(_incoming.event_id, _incoming.flight);

                    const state = usePA_GlobalStore.getState();

                    // 2. Only update the UI state if the user is looking at this specific event
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        set_PA_GlobalObject((prev) => {
                            const prevPlanning = prev?.Planning || {};
                            const prevFlights = Array.isArray(prevPlanning.flights) ? prevPlanning.flights : [];

                            // Map through flights to find the one that changed
                            const updatedFlights = prevFlights.map((f) => {
                                if (String(f.id) === String(_incoming.flight.id)) {
                                    // Return a new object merging the current flight with the incoming financial data
                                    return {
                                        ...f,
                                        amount_total: _incoming.flight.amount_total,
                                        currency: _incoming.flight.currency,
                                        attendee: {
                                            ...(f.attendee || {}),
                                            is_business_expense: _incoming.flight.is_business_expense,
                                            business_expense_amount: _incoming.flight.business_expense_amount
                                        },
                                        status: _incoming.flight.status,
                                        status_timestamp: _incoming.flight.status_timestamp,
                                    };
                                }
                                return f; // Return unchanged if it's not the right flight
                            });

                            return {
                                ...prev,
                                Planning: {
                                    ...prevPlanning,
                                    flights: updatedFlights
                                }
                            };
                        });
                    }
                }
            } else if (action === "E_getFlightStatusResults") {
                if (_incoming.result === "ok"){
                    updateEventFlightStatus(_incoming.event_id, _incoming.statusData);

                    // 2. Only update the UI state if the user is looking at this specific event
                    const state = usePA_GlobalStore.getState();
                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {
                        addIncomingFlightStatusActions(_incoming);
                    }
                }



                /*
                    for the Event Business Authorizations
                */
            } else if (action === "E_updateEventBusinessAuthorizationsResults") {
                if (_incoming.result === "ok"){
                    //update the browser database
                    updateEventBusinessAuthorizations(_incoming.event_id, _incoming.business_authorizations);

                    //if they are currently working on this event
                    const state = usePA_GlobalStore.getState();

                    if (state.triggerSyncSuccess) {
                        state.triggerSyncSuccess();
                    }

                    if (state?.PA_GlobalObject?.Planning?.id === _incoming.event_id) {

                        set_PA_GlobalObject((prev) => {
                            return {
                                Planning: {
                                    ...prev.Planning,
                                    business_authorizations: _incoming.business_authorizations,
                                },
                            };
                        });
                    }
                }


                /*
                    for the Event Business Expense Report
                */
            } else if (action === "E_sendEventExpenseReportResults") {
                if (_incoming.result === "ok"){
                    //add to the business expense report pipeline
                    addIncomingBusinessExpenseReportActions(_incoming);
                }
            } else if (action === "E_getEventExpenseReportDetailsForReviewerResults") {
                if (_incoming.result === "ok"){
                    //add to the business expense report pipeline
                    addIncomingBusinessExpenseReportActions(_incoming);
                }
            } else if (action === "E_getBatchSignedUrlsForGCSForEventExpenseReportResults") {
                if (_incoming.result === "ok"){
                    //add to the business expense report pipeline
                    addIncomingBusinessExpenseReportActions(_incoming);
                }
            } else if (action === "E_resendExpenseReviewEmailResults") {
                if (_incoming.result === "ok"){
                    addIncomingBusinessExpenseReportActions(_incoming);
                }
            } else if (action === "E_revokeExpenseReviewTokenResults") {
                console.log("E_revokeExpenseReviewTokenResults: ", _incoming);
                if (_incoming.result === "ok"){
                    addIncomingBusinessExpenseReportActions(_incoming);
                }
            } else if (action === "E_addExpenseReviewMessageResults") {
                if (_incoming.result === "ok"){
                    addIncomingBusinessExpenseReportActions(_incoming);
                }



                /*
                    for things related to Gemini Concierge
                 */
            } else if (action === "CONCIERGE_TOOL_CALL") {
                setGeminiToolCalls(_incoming.tool);
            } else if (action === "CONCIERGE_RESPONSE") {
                console.log(_incoming);
                setGeminiToolCalls("");
                setGeminiMessages(prev => {
                    const lastMsg = prev[prev.length - 1];

                    // If the last message was a Tool Call, we start a NEW message for the response
                    // If the last message was a partial Gemini response, we append (Streaming)
                    if (lastMsg && lastMsg.attendee_id === "GEMINI_AI" && !lastMsg.isFinal && !lastMsg.isToolCall) {
                        const newHistory = [...prev];
                        newHistory[newHistory.length - 1] = {
                            ...lastMsg,
                            message: lastMsg.message + (_incoming.message || ""),
                            isFinal: _incoming.isFinal,
                            created: Date.now()
                        };
                        return newHistory;
                    } else {
                        return [...prev, {
                            attendee_id: "GEMINI_AI",
                            role: "model",
                            message: _incoming.message || "",
                            isFinal: _incoming.isFinal,
                            created: Date.now()
                        }];
                    }
                });





                /*
                    for things related to the buying a new Event
                 */
            } else if (action === "E_checkNewEventPlanPromoCodeResults") {
                addIncomingEventUpgradeActions(_incoming);

            } else if (action === "E_createNewEventFromPlanningResults") {
                addIncomingEventUpgradeActions(_incoming);


                /*
                    for things related to the saving/updating the Event
                 */
            } else if (action === "E_saveEventUsingNewVersionResults") {
                addIncomingEventUpgradeActions(_incoming);

            } else if (action === "E_saveEventUsingNewVersionWithChangesResults") {
                addIncomingEventUpgradeActions(_incoming);

                /*
                   for things related to Templates
                */
            } else if (action === "T_getTemplateChangesResults") {
                processGetTemplateChanges(_incoming);


            }

        } catch (e) {
            console.error("error : " + e);
        }

    }

    async function processUserLogin(_incoming) {
        console.log("processUserLogin : ");

        try {

            if (_incoming.result === "ok") {

                setAuthenticated(true);

                //create the Account object
                const _account = {};
                _account.id = _incoming.user_id;
                _account.created = _incoming.created;
                _account.last_login = _incoming.last_login;
                _account.last_checkin = _incoming.last_checkin;
                _account.role = _incoming.role;
                _account.username = _incoming.username;
                _account.password = _incoming.password;
                _account.last_password_change = _incoming.last_password_change;
                _account.fname = _incoming.fname;
                _account.lname = _incoming.lname;
                _account.nickname = _incoming.nickname;
                _account.image = _incoming.image;
                _account.avatar = _incoming.avatar;
                _account.language = _incoming.language;
                _account.address = _incoming.address;
                _account.city = _incoming.city;
                _account.state = _incoming.state;
                _account.zip = _incoming.zip;
                _account.country = _incoming.country;
                _account.phone_prefix = _incoming.phone_prefix;
                _account.phone = _incoming.phone;
                _account.mask_phone_number = _incoming.mask_phone_number;
                _account.email = _incoming.email;
                _account.dob = _incoming.dob;
                _account.auto_login = _incoming.auto_login;
                _account.auto_login_type = _incoming.auto_login_type;
                _account.notifications = _incoming.notifications;
                _account.push_notifications = _incoming.push_notifications;
                _account.push_keys = _incoming.push_keys;
                _account.menu_items = _incoming.menu_items;
                _account.events = _incoming.events;
                _account.documents = _incoming.documents;
                _account.my_attendees = _incoming.my_attendees;
                _account.preferred_airport = _incoming.preferred_airport;
                _account.essentials = _incoming.essentials;
                _account.pay_plan = _incoming.pay_plan;
                _account.dark_mode = _incoming.dark_mode;
                _account.show_welcome_tips = _incoming.show_welcome_tips;
                _account.status = _incoming.status;

//                    setAccount(_account);
//                    userAccount.current = _account;
                setUserAuthenticated(true);

                //add the message for the Assistant Thread
                const _assistant_message = {};
                _assistant_message.action = "userLoggedIn";
                _assistant_message.user_id = _incoming.user_id;
                addIncomingAdminsActions(_assistant_message);
                addIncomingConciergeActions(_assistant_message);

                /*
                    before adding the _account to browser storage, see if there is an existing entry
                    this is so if you switch accounts it won't load Events from an Account belonging to another
                    person
                 */
                //checkUserAccount(_account);
                console.log('Syncing account ID:', _incoming.user_id);

                try {
                    // 1. Ensure DB is open and stores exist (using the reusable helper)
                    const db = await openDb('pa', 1, ensureStoresExist);

                    const tx = db.transaction('Account', 'readonly');
                    const store = tx.objectStore('Account');

                    // 2. Retrieve the existing local account using the new efficient key (ID)
                    const localAccount = await store.get(_incoming.user_id);

                    let shouldFetchAllContacts = false;
                    let shouldFetchAllEvents = false;

                    if (localAccount && localAccount.id === _incoming.user_id) {
                        // --- SCENARIO 1: ACCOUNT MATCHES (Update/Merge) ---
                        console.log('Account found and ID matches. Merging data...');

                        // ✅ Deep merge local with server data
                        const mergedAccount = deepMerge(localAccount, _account);

                        // Save merged account (addKeyValue handles the put/update)
                        addAccountValue(_account);
                        setAccount(_account);
                        userAccount.current = _account;

                        // Check local contacts to see if we need updates from the server
                        const contactsInDatabase = await getAllContactsFromDatabase(_account.id);

                        if (contactsInDatabase && contactsInDatabase.length > 0) {
                            console.log(`Found ${contactsInDatabase.length} contacts. Checking for changes...`);

                            // Request changes from server based on local last_mod timestamps
                            const extractedContacts = contactsInDatabase.map(contact => ({
                                id: contact.id,
                                last_mod: contact.last_mod
                            }));

                            const _sendString = {
                                action: "E_getContactsChanges",
                                user_id: _account.id,
                                contacts: extractedContacts,
                            };

                            websocketRef.current.send(JSON.stringify(_sendString) + "|^");

                        } else {
                            // If no local contacts, flag to fetch everything
                            console.log("No contacts in browser storage. Will fetch all from server.");
                            shouldFetchAllContacts = true;
                        }


                        // Check local events to see if we need updates from the server
                        const eventsInDatabase = await getAllEventsFromDatabase(_account.id);

                        if (eventsInDatabase && eventsInDatabase.length > 0) {
                            console.log(`Found ${eventsInDatabase.length} events. Checking for changes...`);

                            // 1. Find the highest last_mod timestamp across all local events
                            // If an event doesn't have a last_mod, it defaults to 0
                            const latestLocalSyncTime = eventsInDatabase.reduce((max, event) => {
                                const currentMod = event.last_mod ? Number(event.last_mod) : 0;
                                return currentMod > max ? currentMod : max;
                            }, 0);


                            const _sendString = {
                                action: "E_getEventChanges",
                                user_id: _account.id,
                                last_sync_time: latestLocalSyncTime,
                            };
                            websocketRef.current.send(JSON.stringify(_sendString) + "|^");

                        } else {
                            // If no local events, flag to fetch everything
                            console.log("No events in browser storage. Will fetch all from server.");
                            shouldFetchAllEvents = true;
                        }

                    } else {
                        // --- SCENARIO 2: ACCOUNT SWITCH or NEW ACCOUNT (Clear and Fetch All) ---
                        console.log('Account switch detected or first login. Clearing local data.');

                        // Clear old contacts first
                        await removeAllContactsFromDatabase();
                        // Clear old events first
                        await removeAllEventsFromDatabase();

                        console.log("AFTER removing any Events from browser database");

                        // Add the new account to storage
                        addAccountValue(_account);
                        setAccount(_account);
                        userAccount.current = _account;

                        shouldFetchAllContacts = true;
                        shouldFetchAllEvents = true;
                    }

                    // 3. Centralized Fetching (Run only if needed)
                    if (shouldFetchAllContacts) {
                        const _sendString = {
                            action: "E_getAllContacts",
                            user_id: _account.id,
                        };
                        websocketRef.current.send(JSON.stringify(_sendString) + "|^");
                    }

                    if (shouldFetchAllEvents) {
                        const _sendString = {
                            action: "E_getAllEvents",
                            user_id: _account.id,
                        };
                        websocketRef.current.send(JSON.stringify(_sendString) + "|^");
                    }

                } catch (error) {
                    console.error("An error occurred during account synchronization:", error);
                    throw error;
                }

                /*
                    get any AI Threads associated with this Attendee
                 */
                const _sendString = {};
                _sendString.action = "getAllAttendeeAssistantThreads";
//                    websocketRef.current.send(JSON.stringify(_sendString) + "|^");

                /*
                    see if anything needs to be done with the current Planning
                    such as: if there are Sample Planner in the attendee - change it to
                    the logged in user
                 */

                console.log("!! the current Planning event : ", usePA_GlobalStore.getState().PA_GlobalObject.Planning);
                if (usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.findIndex((_att) => _att.id === "100000") !== -1){
                    console.log("!! there is Sample Planner in the Planning event");
                    updatePlanningWithLoggedInUser(_account);
                } else {
                    console.log("!! NO Sample Planner : ", usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees);
                }


            } else {
                //bad login
                console.log("login failed .....");

                loginFailed();

            }

        } catch (e) {
            console.log(e);
        }

    }

    function updatePlanningWithLoggedInUser(user_account){
        console.log("updatePlanningWithLoggedInUser");

        /*
            so at this point the Sample Planner is part of the Event in the Planner
            so we can first swap the Sample out with this user
         */
        const _planner = new PAAttendee(
            user_account.fname,
            user_account.lname,
            user_account.email);
        _planner.id = user_account.id;
        _planner.created = user_account.created;
        _planner.role = user_account.role;
        _planner.nickname = user_account.nickname;
        _planner.language = user_account.language;
        _planner.avatar = user_account.avatar;
        _planner.preferred_airport = user_account.preferred_airport;

        _planner.address = user_account.address;
        _planner.city = user_account.city;
        _planner.state = user_account.state;
        _planner.zip = user_account.zip;
        _planner.country = user_account.country;

        _planner.email = user_account.email;
        _planner.dob = user_account.dob;

        _planner.phone_prefix = user_account.phone_prefix;
        _planner.phone = user_account.phone;
        _planner.mask_phone_number = user_account.mask_phone_number;

        _planner.events = user_account.events;
        _planner.documents = user_account.documents;

        console.log("@@@@@@ replace the Sample Planner with : ", _planner);

        //replace the Sample with the logged in user
        set_PA_GlobalObject((prev) => {

            // Remove the Sample and add the New Planner
            const cleanedAttendees = (prev.Planning.attendees || [])
                .filter(att => att.id !== "100000") // <--- REMOVES ID 100000
                .concat(_planner);                   // <--- ADDS REAL USER

            //replace any occurrence in Meals, Lodging, Activities, Flights
            const cleanedActivities = (prev.Planning.activities || []).map((_activity) => {
                // 1. First, create the updated attendees array
                const updatedAttendees = (_activity.attendees || []).map((_att) => {
                    if (_att.id === "100000") {
                        return { ..._att, id: user_account.id };
                    }
                    return _att;
                });

                // 2. IMPORTANT: Return the WHOLE lodging object,
                // but overwrite the attendees property with our new list
                return {
                    ..._activity,
                    attendees: updatedAttendees
                };
            });
            const cleanedFlights = (prev.Planning.flights || []).map((_flight) => {
                // 1. First, create the updated attendees array
                const updatedAttendees = (_flight.attendees || []).map((_att) => {
                    if (_att.id === "100000") {
                        return { ..._att, id: user_account.id };
                    }
                    return _att;
                });

                // 2. IMPORTANT: Return the WHOLE flight object,
                // but overwrite the attendees property with our new list
                return {
                    ..._flight,
                    attendees: updatedAttendees
                };
            });
            const cleanedLodging = (prev.Planning.lodging || []).map((_lodging) => {
                // 1. First, create the updated attendees array
                const updatedAttendees = (_lodging.attendees || []).map((_att) => {
                    if (_att.id === "100000") {
                        return { ..._att, id: user_account.id };
                    }
                    return _att;
                });

                // 2. IMPORTANT: Return the WHOLE lodging object,
                // but overwrite the attendees property with our new list
                return {
                    ..._lodging,
                    attendees: updatedAttendees
                };
            });
            const cleanedMeals = (prev.Planning.meals || []).map((_meal) => {
                // 1. First, create the updated attendees array
                const updatedAttendees = (_meal.attendees || []).map((_att) => {
                    if (_att.id === "100000") {
                        return { ..._att, id: user_account.id };
                    }
                    return _att;
                });

                // 2. IMPORTANT: Return the WHOLE meal object,
                // but overwrite the attendees property with our new list
                return {
                    ..._meal,
                    attendees: updatedAttendees
                };
            });

            //Documents, Ideas, To_Do, Supplies, Notes
            const cleanedIdeas = (prev.Planning.ideas || []).map((_idea) => {
                // Check if the idea was added by the sample OR if the sample commented
                const wasAddedBySample = _idea.added_by === "100000";
                const hasSampleComment = (_idea.comments || []).some(c => c.attendee_id === "100000");

                if (wasAddedBySample || hasSampleComment) {
                    return {
                        ..._idea,
                        // Update the top-level creator
                        added_by: wasAddedBySample ? user_account.id : _idea.added_by,

                        // Map through comments and replace IDs where they match
                        comments: (_idea.comments || []).map((_comment) => {
                            if (_comment.attendee_id === "100000") {
                                return { ..._comment, attendee_id: user_account.id };
                            }
                            return _comment;
                        })
                    };
                }
                return _idea;
            });
            const cleanedNotes = (prev.Planning.notes || []).map((_note) => {
                if (_note.attendee_id === "100000" || _note.tagged.indexOf("100000") !== -1) {
                    return {
                        ..._note,
                        attendee_id: _note.attendee_id === "100000" ? user_account.id : _note.attendee_id,
                        tagged: _note.tagged.indexOf("100000") === -1 ? _note.tagged : _note.tagged.map((_tag) => {
                            return _tag === "100000" ? user_account.id : _tag
                        })
                    }
                }
                return _note;
            });
            const cleanedSupplies = (prev.Planning.supplies || []).map((_supply_item) => {
                if (_supply_item.assigned_by === "100000" || _supply_item.assigned_to === "100000") {
                    return {
                        ..._supply_item,
                        assigned_by: _supply_item.assigned_by === "100000" ? user_account.id : _supply_item.assigned_by,
                        assigned_to: _supply_item.assigned_to === "100000" ? user_account.id : _supply_item.assigned_to
                    }
                }
                return _supply_item;
            });
            const cleanedToDo = (prev.Planning.to_do || []).map((_todo) => {
                if (_todo.created_by === "100000" || _todo.assigned_to === "100000") {
                    return {
                        ..._todo,
                        created_by: _todo.created_by === "100000" ? user_account.id : _todo.created_by,
                        assigned_to: _todo.assigned_to === "100000" ? user_account.id : _todo.assigned_to
                    }
                }
                return _todo;
            });

            //business authorizations, Messages, Photos, Receipts
            const cleanedAuthorizations = (prev.Planning.business_authorizations || {});
            if (cleanedAuthorizations.individualLimits) {
                const limits = { ...cleanedAuthorizations.individualLimits };

                // 1. Check if the sample ID exists as a key
                if (limits["100000"]) {
                    // 2. Create the new key with the user's real ID and copy the data over
                    limits[user_account.id] = limits["100000"];

                    // 3. Remove the old sample key
                    delete limits["100000"];
                }

                // 4. Update the parent object
                cleanedAuthorizations.individualLimits = limits;
            }
            const cleanedMessages = (prev.Planning.messages || []).map((_message) => {
                if (_message.attendee_id === "100000") {
                    return {
                        ..._message,
                        attendee_id: user_account.id
                    }
                }
                return _message;
            });
            const cleanedPhotos = (prev.Planning.photos || []).map((_photo) => {
                if (_photo.attendee_id === "100000") {
                    return {
                        ..._photo,
                        attendee_id: user_account.id
                    }
                }
                return _photo;
            });
            const cleanedReceipts = (prev.Planning.receipts || []).map((_receipt) => {
                if (_receipt.attendee_id === "100000") {
                    return {
                        ..._receipt,
                        attendee_id: user_account.id
                    }
                }
                return _receipt;
            });


            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    attendees: cleanedAttendees,
                    host: [user_account.id],
                    activities: cleanedActivities,
                    flights: cleanedFlights,
                    lodging: cleanedLodging,
                    meals: cleanedMeals,
                    ideas: cleanedIdeas,
                    notes: cleanedNotes,
                    supplies: cleanedSupplies,
                    to_do: cleanedToDo,
                    business_authorizations: cleanedAuthorizations,
                    messages: cleanedMessages,
                    photos: cleanedPhotos,
                    receipts: cleanedReceipts
                },
            }
        });
    }

    function loginFailed() {
        console.log("loginFailed");
        //this alerts the Header and shows the message on the Dialog box
        setLoginFailed(true);
    }

    function processUserLogout(_incoming) {
        console.log("processUserLogout : " + JSON.stringify(_incoming, null, '\t'));

        try {

            if (_incoming.results === "ok") {

                //add the message for the Assistant Thread
                const _assistant_message = {};
                _assistant_message.action = "userLoggedOut";
                _assistant_message.user_id = _incoming.user_id;
                addIncomingAdminsActions(_assistant_message);


                //good logout
                setAuthenticated(false);
                clearAccount();
                clearEvents();
                clearAttendees();

                setSideMenuWidth(0);

            } else {
                //problems logging out
            }
        } catch (e) {
        }
    }

    function processGetTemplateChanges(_incoming){

        try {
            if (_incoming.result === 'ok'){
                browserStorageUpdateTemplates(_incoming.changes).then((result) =>{
                    console.log("After processing Template changes : "+result);
                });
            }
        } catch (e){

        }
    }

    function deepMerge(target, source) {
        if (typeof target !== 'object' || target === null) return source;
        if (typeof source !== 'object' || source === null) return target;

        const output = Array.isArray(target) ? [...target] : { ...target };

        for (const key of Object.keys(source)) {
            const sourceValue = source[key];
            const targetValue = target[key];

            if (Array.isArray(sourceValue)) {
                // If both are arrays, merge unique items by ID if possible
                if (Array.isArray(targetValue)) {
                    output[key] = mergeArraysById(targetValue, sourceValue);
                } else {
                    output[key] = sourceValue;
                }
            } else if (typeof sourceValue === 'object') {
                output[key] = deepMerge(targetValue, sourceValue);
            } else {
                output[key] = sourceValue;
            }
        }

        return output;
    }

    function mergeArraysById(targetArray, sourceArray) {
        const merged = [...targetArray];
        const targetIds = new Set(targetArray.map(item => item?.id));

        for (const item of sourceArray) {
            if (item?.id && !targetIds.has(item.id)) {
                merged.push(item);
            }
        }

        return merged;
    }

    useEffect(() => {
        // 1. Establish the connection
        connectWebSocket();

        // 2. Set up a ping interval every 30 seconds to prevent Cloud Run timeouts (1006)
        const pingInterval = setInterval(() => {
            if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
                sendSocketMessage({ action: "ping" });
            }
        }, 30000);

        // 3. Clean up timer and close socket when the component unmounts
        return () => {
            clearInterval(pingInterval);
            if (websocketRef.current) {
                websocketRef.current.close();
            }
        };
    }, []); // Runs once on mount


    return (

        <PAContext.Provider value={{ activeConnectionCount, activeConnectedUsers, dataArray, dataArrayRef, sendSocketMessage, setAccount, updateGlobalAccount, setAccountDocumentArray, setIsMobileView, setShowSuccessSnackbar, setSideMenuWidth,
            geminiMessages, setGeminiMessages, geminiToolCalls, setGeminiToolCalls, markMessageAsExecuted,
            clearEvents, addEvent, updateEvent, registerDocumentBinary, registerReceiptBinary,
            clearAccount, addAttendee, clearAttendees, updateAttendee, addIncomingActions, setAuthenticated,
            setLoginFailed,
            setPlanning, setPlanningBudget, setPlanningBudgetCurrency, addPlanningAttendee, removePlanningAttendee, setPlanningLodging, setPlanningActivities,
            setPlanningMeals, setPlanningFlights,
            addSuggestionsLodging, clearSuggestionsLodging,
            addSuggestionsFlights, clearSuggestionsFlights,
            addSuggestionsMeals, clearSuggestionsMeals,
            addSuggestionsTours, clearSuggestionsTours,
            addSuggestionsUnique, clearSuggestionsUnique,
            addPlanningLibrary, clearPlanning, addPartnership, clearPartnerships,
            setWorkingOnEventId, removeFirstAccountActions,
            removeFirstConciergeSignupActions, removeFirstEventUpgradeActions, removeFirstSuppliesActions,
            removeFirstFlightPlanningActions, removeFirstFlightStatusActions, removeFirstIncomingAdminsActions, removeFirstDialogActions,
            removeFirstMessagesActions, removeFirstBusinessExpenseReportActions }} >
            {children}
        </PAContext.Provider>

    );
};

export { PAContext, PAContextProvider };
